// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purchase-main-component {
  background: #f5f5f5;
  width: 100%;
  /* height: 90vh; */
  overflow: hidden;
}

.complete-campaign-text-row {
  display: flex;
  border-bottom: 1px solid #d2d2d2;
  background: #f5f5f5;
  padding: 10px 0px 31px 74px;
  align-items: center;
  flex-shrink: 0;
  gap: 2%;
  position: sticky;
}
.step-padding-depend-step-class {
  padding: 10px 0px 31px 345px !important;
}
.step-padding-depend-step-class-bread {
  padding-left: 345px !important;
}
.complete-campaign-text-row-bread {
  padding-left: 75px;
  padding-top: 15px;
}
.complete-campaign-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.review-secure-row {
  display: flex;
  align-items: center;
  gap: 19px;
  padding: 20px;
}
.review-steps-custom.ant-steps .ant-steps-item-process .ant-steps-item-icon {
  background-color: #d2042d;
  border-color: #d2042d;
}
.review-steps-custom.ant-steps {
  width: 20%;
}
.review-steps-custom .ant-steps-item::before {
  background-color: transparent !important;
}
.review-steps-custom.ant-steps .ant-steps-item-finish .ant-steps-item-icon {
  background-color: #d2042d !important;
  border-color: #d2042d !important;
}
.review-steps-custom.ant-steps
  .ant-steps-item-finish
  .ant-steps-item-icon
  > .ant-steps-icon {
  color: white !important;
}

.ant-steps-item-title:hover {
  cursor: pointer;
}

.order-summary-apply-term-row {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: center;
  align-items: flex-start;
  padding: 0px 15px;
  margin-left: 0px !important;
}
.card-summary-card {
  width: 100%;
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.amp-note-store-card {
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}
.amp-note-store-card.ant-card .ant-card-body {
  width: 100%;
  padding-top: 24px !important;
}

.order-summary-heading {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
}
.order-summary-heading-amount {
  font-family: Roboto;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 20px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Primary-500, #d2042d);
}
.order-summary-scroll-main-container {
  overflow-y: auto;
  max-height: 530px;
  padding: 10px !important;
}
.payments-campaign-id {
  color: var(--Colors-Text-400, #3b3f3d);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 1.5rem;
}

.urban-billboard-blitz-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-decoration: underline;
  margin-right: 10px;
  cursor: pointer;
}
.urban-billboard-sub-card {
  border-radius: 5px;
  background: #f7f7f7;
  margin-top: 15px;
}
.urban-billboard-sub-card.ant-card .ant-card-body {
  padding-top: 15px !important;
  border-radius: 0 0 8px 8px;
}
.products-text-non {
  color: var(--Colors-Text-200, #8e9190);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.campaigns-upfront-products-row {
  display: flex;
  flex-direction: row;
  align-content: center;
  flex-wrap: nowrap;
}
.upfront-text-label-name {
  color: var(--Colors-Secondary-500, #8e9190);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.time-square-row {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  margin-top: 16px;
  flex-wrap: nowrap;
}

.products-title-col {
  max-width: 70%;
  display: flex;
  align-items: center;
}
.products-title-col-value {
  width: 75%;
  display: flex;
  justify-content: flex-end;
}
.total-campaign-total-price-col {
  width: 25%;
  display: flex;
  justify-content: flex-end;
}
.collapse-arrow-mark {
  width: 10px !important;
  height: 16px !important;
  margin-right: 10px !important;
  cursor: pointer;
}
.product-count-collapse {
  color: var(--Colors-Text-200, #8e9190);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.waiting-for-approval-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Primary-300, #e15772);
}
.approved-text-color {
  color: #008342 !important;
  font-size: 14px !important;
}
.rejected-text-color {
  color: #d2042d;
  font-size: 14px !important;
}
.withdraw-text {
  font-family: Roboto;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: var(--Colors-Primary-500, #d2042d);
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-top: 10px;
}
.collapse-arrow-mark.open {
  transform: rotate(90deg);
  transition: transform 0.3s ease;
}

.time-square-digital-col-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-right: 10px;
}
.time-square-digital-price {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.offer-applied-cost-price {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.offer-applied-text {
  color: var(--Colors-Secondary-500, #008342);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.down-town-static-row {
  display: flex;
  justify-content: space-between;
  margin-top: 1.5rem;
}
.total-campaign-row,
.draw-help-col {
  display: flex;
  justify-content: space-between;
}
.draw-help-col {
  margin-top: 18px;
}
.draw-text {
  color: #5b5e5d;
}
.sign-help-text {
  font-weight: 400;
  font-size: 16px;
}
.total-campaign-amount-label-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.campaign-diver.ant-divider-horizontal {
  height: 0px;
  flex-shrink: 0;
  stroke-width: 1px;
  stroke: var(--Colors-Text-300, #5b5e5d);
}
.total-campaign-total-price-text {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.total-campaign-total-price-text-default {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.apply-term-text {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.terms-withdrawn-row {
  display: flex;
  gap: 10px;
}
.withdrawn-text-badge {
  background-color: #d2042d;
  border-radius: 4px;
  padding: 2px;
}
.withdrawn-text {
  color: white !important;
}

.downout-lined-icon {
  width: 16px !important;
  height: 8px !important;
  stroke-width: 2px !important;
  stroke: var(--Colors-Text-500, #0a0f0d) !important;
  cursor: pointer !important;
}
.balance-amount-row {
  margin-top: 2%;
}
.balance-amount-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.payment-due-row {
  align-items: center;
  width: 100%;
  margin-top: 5%;
}
.payment-due-col {
  width: 50%;
}
.balance-amount-input-col {
  width: 50%;
}
.highlighted-balance-col {
  width: 45%;
}
.delete-icon-col {
  width: 5%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.delete-icon-another-term {
  cursor: pointer;
  width: 24px !important;
  height: 24px !important;
  aspect-ratio: 1/1;
}
.delete-icon-another-term.delete-disabled {
  cursor: not-allowed !important;
  opacity: 0.4;
  pointer-events: none;
}
.delete-icon-another-term:hover {
  opacity: 0.7;
}

.delete-icon-col:hover {
  background-color: #d2d2d2;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  padding: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.choose-payment-selector-component {
  width: 100%;
  height: 40px;
}
.choose-payment-selector-component .ant-select-selection-placeholder {
  color: var(--Colors-Text-200, #8e9190) !important;
  font-family: Roboto !important;
  font-size: 13px !important;
  font-style: normal;
  font-weight: 400 !important;
  line-height: 24px !important;
  flex: 1 0 !important;
}
.choose-payment-selector-dropdown.ant-select-dropdown {
  width: 370px !important;
}
.choose-payment-select-options {
  display: flex;
  width: 100%;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 3px;
  background: #fff;
}

.choose-payment-selector-dropdown .choose-payment-select-options {
  padding: 8px;
  border-radius: 6px;
  transition: background-color 0.3s;
}

.choose-payment-selector-dropdown .choose-payment-select-options:hover {
  background-color: #d2042d;
  color: #fff;
}

.choose-payment-selector-dropdown
  .choose-payment-select-options:hover
  .choose-payment-select-label,
.choose-payment-selector-dropdown
  .choose-payment-select-options:hover
  .choose-payment-select-description {
  color: #fff;
}

.choose-payment-selector-dropdown
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
  background-color: transparent !important;
}
.choose-payment-select-label {
  align-self: stretch;
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.choose-payment-select-description {
  color: var(--Colors-Text-300, #5b5e5d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.add-another-term-row {
  margin-top: 5%;
  width: 100%;
  margin-top: 5%;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
  align-items: center;
}
.add-another-term-col {
  width: 100%;
}

.add-another-term-btn {
  width: 100%;
}
.add-icon {
  display: flex;
  width: 20px;
  height: auto;
}
.add-another-term-btn-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.add-another-term-btn-text:hover {
  text-decoration: underline !important;
}
.choose-payment-selector-component.ant-select-outlined:not(
    .ant-select-customize-input
  )
  .ant-select-selector {
  border: none !important;
  background: #f5f5f5;
}
.choose-payment-selector-component.ant-select .ant-select-arrow {
  color: #000 !important;
}
.remove-all-term-plan-row {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}
.remove-all-terms-plan-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
.add-more-money-card {
  display: flex;
  padding: 25px 25px 25px 25px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  margin-top: 2%;
}
.add-more-money-optional-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.enter-amount-label-row {
  width: 100%;
  margin-top: 10%;
}
.dollar-icon-enter-amount {
  color: var(--Colors-Background-100, #fcfcfc);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.enter-amount-label .ant-input-group-addon {
  align-items: center;
  background: var(--Colors-Text-500, #0a0f0d);
}
.enter-amount-custom-input input {
  color: var(--Colors-Text-200, #8e9190);
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  flex: 1 0;
}
.enter-amount-custom-input .ant-input-group .ant-input-group-addon:last-child {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
  color: var(--Colors-Text-200, #8e9190) !important;
  font-family: Roboto !important;
  font-size: 13px !;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  background-color: #8e9190 !important;
}
.enter-amount-custom-input .ant-input-group .ant-input {
  color: var(--Colors-Text-500, #0a0f0d) !important;
  font-family: Roboto;
  font-size: 16px;
  background-color: #f5f5f5;
  padding: 4px 4px !important;
}
.enter-amount-custom-input:focus,
.enter-amount-custom-input .ant-input-outlined:focus-within {
  border-color: #000 !important;
  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
  outline: 0;
  background-color: #ffffff;
}
.enter-amount-label {
  display: flex;
  height: 40px;
  padding: 10px 0px 10px 0px;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #f5f5f5 !important;
  width: 100%;
}
.proceed-to-payment-card {
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  height: auto;
  align-self: stretch;
}
.proceed-to-payment-row {
  display: flex;
  justify-content: space-between;
  margin-top: 5%;
}
.remaining-balance-row {
  display: flex;
  justify-content: space-between;
  margin-top: 5%;
}
.upfront-payment-text {
  color: var(--Colors-Text-300, #5b5e5d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.upfront-payment-price-text {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.note-apply-condition-row {
  display: flex;
  width: 100%;
  height: auto;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 3px;
  background: #ffedf1;
  margin-top: 5%;
}
.note-apply-condition-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.proceed-to-payment-button-row {
  width: 100%;
  margin-top: 5%;
  margin-left: 0px !important;
}
.proceed-to-payment-btn {
  display: flex;
  width: 100%;
  height: 50px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  margin-bottom: 1rem;
}
.proceed-to-payment-btn:hover {
  background-color: #d2042d !important;
  border-color: #d2042d !important;
  color: #fff !important;
}
.proceed-to-checkout:hover {
  background-color: #d2042d !important;
  color: white !important;
  border: none !important;
}
.proceed-to-payment-btn-text {
  color: #fff;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.secure-payment-tab-row {
  width: 100%;
  overflow-x: auto;
  gap: 0.5rem;
  padding-inline: 4rem;
}
.credit-debit-collapse-component {
  background-color: #fff !important;
}
.credit-debit-collapse-component {
  background-color: #fff !important;
}

.credit-debit-collapse-component
  .ant-collapse-header
  .ant-collapse-header-text {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.credit-debit-collapse-component .ant-collapse-header .ant-collapse-arrow {
  font-size: larger !important;
}
.payment-summary-card {
  height: auto;
  align-self: stretch;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}
.card-number-field-row {
  width: 100%;
  margin-top: 20px;
}
.card-details-space {
  flex-direction: column !important;
  width: 85% !important;
}
.card-number-input-field {
  display: flex;
  width: 100%;
  height: 44px;
  padding: 10px 20px 10px 14px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #f5f5f5;
}

.card-number-input-field.ant-input-filled:hover {
  border-color: #000000;
  background-color: #f5f5f5;
}

.card-number-input-field.ant-input-filled:focus {
  border-color: #000000;
  background-color: #f5f5f5;
  box-shadow: none;
}
.card-expiry-cvv-row.ant-row {
  display: flex !important;
  gap: 1.5rem !important;
  align-items: center;
  width: 85%;
}
.card-expiry-month-col {
  width: 45%;
}
.card-input-cvv-field {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 10px 20px 10px 14px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #f5f5f5;
}
.card-input-cvv-field.ant-input-filled:hover {
  border-color: #000000;
  background-color: #f5f5f5;
}
.card-input-cvv-field.ant-input-filled:focus {
  border-color: #000000 !important;
  background-color: #f5f5f5;
}
.card-month-input-field {
  display: flex;
  width: 100%;
  height: 40px;
  padding: 10px 20px 10px 14px;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #f5f5f5;
  font-size: 14px !important;
  font-weight: 400 !important;
}
/* CardInput.css */

.card-element-wrapper {
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  cursor: pointer;
  background-color: #f5f5f5;
  margin-bottom: 20px;
}
.card-element-wrapper.active {
  border-color: #000000 !important;
}
.card-element-inner {
  flex: 1 1;
}
.payment-select-country.ant-select-single.ant-select-show-arrow
  .ant-select-selection-item {
  font-size: 14px !important;
  color: #000000 !important;
}
.payment-select-country {
  width: 100%;
  height: 2.5rem;
  align-items: center;
  border-radius: 0.3125rem;
  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);
  background: #f5f5f5;
  padding-top: 0px !important;
}
.payment-select-country.with-padding {
  padding-top: 1rem !important;
}
.payment-select-country .ant-select-selector {
  border: none !important;
  background: #f5f5f5 !important;
}
.card-month-input-field.ant-input-filled:hover {
  border-color: #000000;
  background-color: #f5f5f5;
}
.card-month-input-field.ant-input-filled:focus {
  border-color: #000000;
  background-color: #f5f5f5;
}

.card-expiry-number-col {
  width: 45%;
}
.save-card-future-row {
  display: flex;
  gap: 2%;
  margin-top: 1.5rem;
  width: 100%;
}
.save-card-future-text {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.card-details-secured-row {
  display: flex;
  margin-top: 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.card-details-secured-container {
  display: flex;
  width: 100%;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 5px;
  background: #ffecf0;
}
.card-details-secured-text {
  color: #d2042d;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.accepted-card-row {
  display: flex;
  margin-top: 1.2rem;
}
.accepted-card-text {
  color: var(--Colors-Text-300, #5b5e5d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.cards-maintaing-component {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
  align-content: flex-start;
  margin-top: 1rem;
  gap: 1rem;
}
.pay-by-check-main-container {
  width: 100%;
  height: auto;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 2px 2px 13.1px 0px #0000000d;
}
.check-upload-container {
  text-align: center;
  border-radius: 0.625rem;
  border: 2px dashed #d2042d;
  width: 100%;
  height: 166px;
  background: #fff4f6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.check-upload-submitted {
  text-align: center;
  /* border-radius: 0.625rem; */
  border: none !important;
  width: 100%;
  height: 166px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.final-check-images-row {
  width: 100%;
  display: flex;
  height: 100%;
}
.final-check-images-front-col {
  width: 50%;
}
.final-check-images-back-col {
  width: 50%;
}
.uploaded-image {
  width: 90% !important;
  height: 122px !important;
}
.final-check-review-confirm {
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: center;
  align-items: flex-start;
  margin-top: 2rem;
}
.check-review-confirm {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000;
}
.check-user-details {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: var(--Colors-Text-400, #3b3f3d);
}
.view-more-details-container-check {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}
.view-more-details-container-check-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  color: #d2042d;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  cursor: pointer;
}
.base-text-under-view-details {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-300, #5b5e5d);
  margin-top: 2rem;
}
.check-upload-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: Font/Font Size/p;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  cursor: pointer;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  color: #d2042d;
}
.check-front-view-text-row {
  display: flex;
  margin-bottom: 1rem;
  flex-direction: row;
  align-content: center;
  justify-content: flex-start;
  margin-bottom: 1rem;
}
.check-front-view-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #000000;
}
.check-upload-section-text-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}
.check-upload-modal.ant-modal .ant-modal-title {
  font-family: Montserrat;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
}
.check-upload-modal.ant-modal {
  width: 900px !important;
}
.check-upload-front-back-row {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  gap: 4%;
  margin-top: 2rem;
}
.check-upload-front-col {
  width: 48%;
}
.check-upload-back-col {
  width: 48%;
}
.check-instructions-row {
  display: flex;
  margin-top: 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: flex-start;
}
.check-instructions-list.ant-list .ant-list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 0;
  color: rgba(0, 0, 0, 0.88);
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
}
.check-user-details-container {
  display: flex;
  width: 100%;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}
.sample-check-image-container {
  width: 100% !important;
  margin-top: 1rem;
}
.check-user-details-common-col.ant-col {
  width: 35% !important;
}
.check-image-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
}
.check-close-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 16px;
  color: #333;
  cursor: pointer;
  z-index: 1;
  background: #fff;
  border-radius: 50%;
  padding: 2px;
}
.demo-check-image.ant-image .ant-image-img {
  width: 100% !important;
  height: 100% !important;
  border-radius: 0.5rem !important;
}
.sample-check-image-container .ant-image {
  position: relative;
  display: inline-block;
  width: 100% !important;
  height: 100% !important;
}
.check-footer-text-links {
  cursor: pointer;
  font-family: Roboto;
  font-weight: 500;
  color: var(--Colors-Primary-500, #d2042d);
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
}
.check-image-card {
  display: flex;
  /* padding: 25px 25px 25px 25px; */
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 10px;
  background: #fff;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
  margin-top: 2%;
}
.check-image-card.ant-card .ant-card-body {
  padding-top: 15px !important;
  border-radius: 0 0 8px 8px;
}
.check-custom-cancel-button {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  background: #e0e0e0;
  color: #000;
}
.check-custom-cancel-button:hover,
.check-custom-cancel-button:focus {
  background-color: #e0e0e0 !important;
  color: #000 !important;
  border-color: #e0e0e0 !important;
}
.check-custom-ok-button {
  background: #d2042d;
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
}
.payment-summary-col {
  width: 25%;
  height: auto;
}
.payment-summary-text {
  color: #000;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.common-summary-row {
  display: flex;
  justify-content: space-between;
  margin-top: 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 10px;
}
.common-summary-col {
  width: 60%;
}
.summary-total-amount-header {
  color: var(--Colors-Text-300, #5b5e5d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.summary-total-amount {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.summary-applied-term-plan-row {
  margin-top: 2rem;
}
.summary-applied-term-plan {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-small, 13px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.summary-total-pay-now {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.summary-modify-payment-plan-row {
  display: flex;
  justify-content: center;
  text-align: center;
  margin-top: 1.8rem;
}
.summary-modify-payment-plan-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}
.secure-payment-final-btn {
  display: flex;
  width: 100%;
  height: 50px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
  margin-top: 1rem;
}
.secure-payment-final-btn:hover {
  background-color: #d2042d !important;
  border-color: #d2042d !important;
}
.secure-payment-final-btn-text {
  color: #fff;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.payment-success-container-div {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin-top: 7%;
}
.payment-success-container-card {
  width: 25%;
  background: #ffffff;
  box-shadow: 0px 236px 66px 0px #00000000;
}
.payment-success-icon-row {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.payment-success-main-text-col {
  margin-top: 10px;
}
.payment-success-main-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-h5, 23px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.payment-success-divider-row {
  display: flex;
  justify-content: center;
  width: 80%;
}
.success-total-amount-paid-row {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  margin-top: 2rem;
}
.common-success-total-amount-col {
  width: 50%;
}
.common-success-total-amount-col-campaign {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: space-between;
  align-items: flex-start;
}
.success-total-amount-paid-label {
  color: var(--Colors-Text-200, #8e9190);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.success-total-amount-paid-label-value {
  color: var(--Colors-Text-500, #0a0f0d);
  text-align: right;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}
.payment-success-confirmation-email-row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 0.5rem;
}
.payment-success-confirmation-email-text {
  color: var(--Colors-Text-300, #5b5e5d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.payment-success-go-to-dashboard-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
}
.payment-success-go-to-dashboard-text {
  color: var(--Colors-Primary-500, #d2042d);
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  cursor: pointer;
}
.payment-success-download-invoice-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}
.payment-success-download-invoice-btn {
  display: flex;
  width: 100%;
  height: 50px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: var(--Colors-Primary-500, #d2042d);
}
.payment-success-download-invoice-btn:hover {
  background: var(--Colors-Primary-500, #d2042d) !important;
  border-color: #d2042d !important;
}
.payment-success-download-invoice-btn-text {
  color: #fff;
  font-family: Roboto;
  font-size: var(--Font-Font-Size-p, 16px);
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.amp-does-not-store-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 3rem;
}
.amp-does-not-store-card.ant-card .ant-card-body {
  padding-bottom: 0px !important;
}
.amp-does-not-store-card-row {
  display: flex;
  justify-content: center;
}
.amp-does-not-store-card {
  display: flex;
  width: 100%;
  gap: 8px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.amp-does-not-store-card-terms {
  display: flex;
  width: 100%;
  gap: 8px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 2px 2px 13.1px 0px #0000000d;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: center;
  align-items: center;
}
.amp-does-not-store-card-terms.ant-card .ant-card-body {
  padding-bottom: 0px !important;
}
.amp-store-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: center;
  color: #000000;
}
.amp-store-highleted {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  color: var(--Colors-Primary-500, #d2042d);
  text-decoration-thickness: 0%;
  text-decoration-skip-ink: auto;
  cursor: pointer;
}
.review-steps-custom.ant-steps
  .ant-steps-item-container:focus-visible
  .ant-steps-item-icon {
  outline: transparent !important;
  outline-offset: 1px;
  transition:
    outline-offset 0s,
    outline 0s;
}
.payments-empty-campaigns-container {
  margin-top: 0px !important;
  width: 100% !important;
}
.step-2-common-col-1 {
  width: 20%;
}
.step-2-common-col-2 {
  width: 60%;
}
.step-2-common-col-3 {
  width: 20%;
  display: flex;
  justify-content: center;
}
.term-apply-final-btn-text {
  color: #fff;
  font-family: Roboto;
  font-size: 1rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.term-apply-final-btn {
  display: flex;
  width: 100%;
  padding: 0.5rem 1.25rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 0.3125rem;
  background: #d2042d;
}
.term-apply-final-btn:hover {
  background: #d2042d !important;
}
.term-apply-final-btn.ant-btn-variant-solid:disabled {
  background: #d2042d !important;
}
.btn-disabled-parent .term-apply-final-btn {
  cursor: not-allowed !important;
  border-color: #d9d9d9 !important;
  color: #fff !important;
  background: #d2042d !important;
  box-shadow: none !important;
}
.remove-user-term-btn {
  height: 40px;
  padding: 8px 20px;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  border: 1px solid #000;
  background: #fff;
}
.remove-user-term-btn:hover {
  border-color: #000 !important;
  color: #0a0f0d !important;
}
.remove-user-term-btn-text {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.complete-to-payment-btn {
  height: 40px;
  padding: 8px 20px;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 5px;
  background: #d2042d !important;
}
.complete-to-payment-btn-text {
  color: #fff;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.terms-user-warning-modal .ant-modal-title {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h6, 19px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.text-to-continue-or-remove {
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.next-to-terms-version {
  width: 100%;
  height: 45px;
  gap: 8px;
  border-radius: 5px;
  padding: 8px;
  background: var(--Colors-Primary-500, #d2042d);
  margin-top: 1rem;
  cursor: pointer;
}
.next-to-terms-version:hover {
  background-color: #d2042d !important;
  color: #ffffff !important;
}
.next-to-terms-version-text.ant-typography {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ffffff;
}
.back-arrow-payment-main {
  cursor: pointer;
}
.upout-lined-icon {
  cursor: pointer;
}
.late-charges-will-apply {
  width: 100%;
  height: 55;
  border-radius: 5px;
  padding-top: 8px;
  padding-right: 14px;
  padding-bottom: 8px;
  padding-left: 14px;
  gap: 8px;
  background: #ffecf0;
}
.late-charges-will-apply-text {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 19.5px;
  letter-spacing: 0%;
}
.check-payment-main-container {
  background: #f5f5f5;
  width: 100%;
  overflow-x: hidden;
}
.check-payments-button-version-row {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}
.check-payments-button-version-cancel.ant-btn-variant-solid {
  background: #f0f0f0 !important;
  border-radius: 5px;
  padding-top: 8px;
  padding-right: 34px;
  padding-bottom: 8px;
  padding-left: 34px;
  width: 100%;
  height: 40px;
}
.check-payments-button-version-cancel.ant-btn-primary:hover {
  background-color: #f0f0f0 !important ;
}
.check-payments-button-version-cancel-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--Colors-Text-500, #0a0f0d);
}
.check-payments-button-version-submit {
  height: 40px;
  border-radius: 5px;
  padding-top: 8px;
  padding-right: 34px;
  padding-bottom: 8px;
  padding-left: 34px;
  width: 100%;
  background: var(--Colors-Primary-500, #d2042d);
}
.check-payments-button-version-submit:hover {
  background-color: #d2042d !important;
}
.check-payments-button-version-submit-text {
  font-family: Roboto;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #fff;
}
.check-instructions-list.ant-list {
  padding: 10px !important;
}
.displaying-total-campaigns-card {
  display: flex;
  width: 100%;
}
.review-steps-custom.ant-steps.ant-steps-navigation
  .ant-steps-item-container:hover {
  color: #8e9190 !important;
}
.empty-box-payments {
  margin-bottom: 3rem !important;
}
.review-steps-custom.ant-steps.ant-steps-navigation
  .ant-steps-item-container
  .ant-steps-item-title {
  max-width: 100% !important;
  padding-inline-end: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 10px !important;
  font-weight: 700;
  font-size: 16px;
}
.review-steps-custom.ant-steps.ant-steps-horizontal:not(
    .ant-steps-label-vertical
  )
  .ant-steps-item {
  padding-inline-start: 32px !important;
  white-space: nowrap !important;
}
.error-campaigns-div {
  display: flex;
  flex-direction: column;
}
.secure-payment-final-btn.ant-btn-variant-outlined:disabled {
  background-color: #d2042d !important;
}
.secure-payment-final-btn:hover {
  background-color: #910621 !important;
}

.io-footer {
  padding-left: 26px;
  padding-top: 32px;
  padding-bottom: 20px;
  background: #fff;
  /* width: 64.5vw; */
  /* display: flex; */
  align-items: center;
  font-size: 16px;
  font-weight: 400;
  color: #5b5e5d;
  margin-top: 24px;
  border-radius: 10px;
}
.info-text {
  width: 70%;
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.docu-sign-buttons {
  background: #d2042d !important;
  color: #fff !important;
}
.docu-sign-buttons:hover {
  border-color: #d2042d !important;
}
.continue-btn {
  display: flex;
  justify-self: flex-end;
  right: 3rem;
}
.confirm-docusign {
  padding: 16px 20px;
  display: flex;
  justify-self: right;
}
.agree-docusign-terms {
  text-decoration: underline;
  margin: 0 5px 0 5px;
}
.docu-sign-option-container {
  margin-left: 12px;
  margin-top: 24px;
}
.sign-card {
  background: #f5f5f5;
  padding-bottom: 30px;
}
.sign-header {
  margin-bottom: 23px;
}
.sign-sub-header {
  color: #0a0a0a;
  margin-bottom: 33px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.agreement-title {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 12px;
}
.agreement-content {
  color: #5b5e5d;
}
.signed-label {
  margin-top: 20px;
}
.agreement-button-labels {
  border: none;
  pointer-events: none;
  width: 279px;
  height: 40px;
}
.e-sign-header {
  margin-top: 32px;
  margin-bottom: 18px;
}
.draw-sign-space {
  height: 210px;
  background: #fff;
  border: 1px dashed #8b8b8b;
  stroke-dasharray: 12, 6;
  border-radius: 10px;
}
.launch-header {
  color: #000;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 6px;
}
@media (max-width: 1440px) {
  .negotiate-assets-table {
    /* max-width: 80vh !important; */
    overflow-x: auto;
  }
  .negotiate-assets-table .ant-table-tbody > tr > td {
    white-space: nowrap;
    word-break: normal;
  }
  .secure-payment-tab-row {
   padding-inline: 0rem;
  }
}
@media (min-width: 1025px) and (max-width: 1440px) {
  .review-secure-row {
    padding: 10px !important;
  }
  .complete-campaign-text-row {
    padding: 25px 0px 25px 188px !important;
  }
  .time-square-digital-col-text {
    font-size: var(--Font-Font-Size-p, 16px) !important;
  }
  .time-square-digital-price {
    font-size: var(--Font-Font-Size-p, 16px) !important;
  }
  .save-card-future-text {
    font-size: 15px !important;
  }
  .payment-summary-text {
    font-size: var(--Font-Font-Size-h6, 18px) !important;
  }
  .credit-debit-collapse-component
    .ant-collapse-header
    .ant-collapse-header-text {
    font-size: var(--Font-Font-Size-h6, 18px) !important;
  }
  .payment-summary-col {
    height: auto;
  }

  .review-steps-custom.ant-steps {
    width: 30% !important;
  }
  .urban-billboard-blitz-text {
    font-size: var(--Font-Font-Size-h6, 18px) !important;
  }
  .choose-payment-selector-dropdown
    .ant-select-single.ant-select-show-arrow
    .ant-select-selection-placeholder {
    font-size: 12px !important;
  }
  .choose-payment-selector-dropdown.ant-select-dropdown {
    width: 305px !important;
  }
  .enter-amount-custom-input .ant-input-group .ant-input {
    font-size: 12px !important;
  }
  .add-another-term-btn-text {
    font-size: 14px !important;
  }
  .delete-icon-another-term {
    width: 20px !important;
    height: 20px !important;
  }
  .highlighted-balance-col {
    width: 43% !important;
  }
  .payment-due-col {
    width: 47% !important;
  }
  .add-another-term-btn-icon {
    width: 14px !important;
    height: 14px !important;
  }
  .add-more-money-card {
    padding: 0px !important;
  }
  .payment-success-container-card {
    width: 35% !important;
  }
}
@media (min-width: 768px) and (max-width: 850px) {
  .card-expiry-cvv-row.ant-row {
    align-items: center;
    width: 100% !important;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .review-steps-custom.ant-steps {
    width: 40% !important;
  }
  .complete-campaign-text-row {
    padding: 25px 0px 25px 100px !important;
  }
  .highlight-step {
    padding: 25px 0px 25px 45px !important;
  }
  .review-secure-row {
    padding: 20px !important;
  }
  .urban-billboard-row {
    margin-top: 0.7rem !important;
  }
  .choose-payment-selector-component.ant-select-selection-placeholder {
    font-size: 12px !important;
  }
  .enter-amount-custom-input .ant-input-group .ant-input {
    font-size: 14px !important;
  }
  .choose-payment-selector-component .ant-select-selection-placeholder {
    font-size: 12px !important;
  }
  .order-summary-col {
    margin-inline-start: 0% !important;
  }
  .payment-due-col {
    width: 47% !important;
  }
  .payment-due-responsive .payment-due-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    display: block;
  }
  .payment-due-responsive .balance-amount-input-col {
    width: 100% !important;
    max-width: 100% !important;
    flex: 0 0 100% !important;
    display: block;
  }
  .payment-due-responsive .highlighted-balance-col {
    width: 80% !important;
    max-width: 80% !important;
    flex: 0 0 100% !important;
    display: block;
  }
  .payment-due-responsive .delete-icon-col {
    display: block;
  }
  .delete-icon-col {
    text-align: right;
    margin-top: 8px;
  }

  .balance-amount-input-col {
    margin-top: 8px;
  }
  .choose-payment-selector-dropdown.ant-select-dropdown {
    width: 306px !important;
    inset: 372px auto auto 596px !important;
  }
  .add-more-money-card {
    padding: 0px !important;
  }
  .upfront-payment-text {
    font-size: 15px !important;
  }
  .proceed-to-payment-btn {
    height: 40px !important;
  }
  .proceed-to-payment-btn-text {
    font-size: var(--Font-Font-Size-p, 15px) !important;
  }
  .urban-billboard-blitz-text {
    font-size: var(--Font-Font-Size-h6, 17px) !important;
  }
  .save-card-future-text {
    font-size: 14px !important;
  }
  .accepted-card-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .summary-total-amount {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .summary-total-amount-header {
    font-size: var(--Font-Font-Size-p, 15px) !important;
  }
  .summary-total-pay-now {
    font-size: var(--Font-Font-Size-p, 15px) !important;
  }
  .step-2-common-col-1 {
    width: 5% !important;
  }
  .step-2-common-col-2 {
    width: 70% !important;
  }
  .payment-success-container-card {
    width: 45% !important;
  }
  .payments-empty-campaigns-container {
    padding: 0.5rem !important;
  }
  .empty-box-payments {
    margin-bottom: 1rem !important;
  }
}
@media (max-width: 767px) {
  .complete-campaign-text-row {
    font-size: 19px;
  }
  .confirm-docusign {
    /* margin: auto; */
    justify-content: center;
    right: 4rem;
    bottom: 0.5rem;
  }
  .agreement-button-labels {
    width: max-content;
  }
  .io-container .launch-campaign-text {
    font-size: 13px;
    padding: 10px;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .back-arrow-payment-main {
    width: 25px !important;
    height: 25px !important;
  }
  .complete-campaign-text-row {
    padding: 15px 0px 15px 0px !important;
    margin-inline-start: 10px !important;
    gap: 10px !important;
  }
  .complete-campaign-text {
    font-size: var(--Font-Font-Size-h5, 16px) !important;
  }
  .order-summary-scroll-main-container {
    overflow-y: unset !important;
    max-height: none !important;
  }
  .order-summary-col {
    margin-inline-start: 0% !important;
  }
  .amp-does-not-store-card {
    margin-top: 1rem !important;
    margin: 10px !important;
  }
  .order-summary-apply-term-row {
    margin: 0px !important;
  }
  .payment-due-col {
    width: 100%;
  }
  .balance-amount-input-col {
    width: 100%;
  }
  .step-2-common-col-1 {
    width: 0% !important;
  }
  .step-2-common-col-2 {
    width: 100%;
  }
  .amp-does-not-store-row {
    margin-top: 1rem !important;
  }
  .products-title-col {
    max-width: 60%;
    display: flex;
    align-items: center;
  }
}
@media (min-width: 426px) and (max-width: 768px) {
  .complete-campaign-text-row {
    padding: 31px 0px 31px 38px !important;
  }
  .review-secure-row {
    width: 100% !important;
    padding: 10px !important;
  }
  .review-steps-custom.ant-steps {
    width: 60% !important;
  }
  .payment-due-row {
    gap: 5% !important;
    display: flex !important;
  }
  .term-apply-final-btn {
    height: 40px !important;
  }
  .add-another-term-btn-text {
    font-size: 19px !important;
  }
  .remove-all-terms-plan-text {
    font-size: 19px !important;
  }
  .order-summary-col {
    margin-inline-start: 2% !important;
  }
  .urban-billboard-row {
    margin-top: 0px !important;
  }
}
@media (min-width: 376px) and (max-width: 425px) {
  .review-steps-custom.ant-steps {
    width: 100% !important;
    display: flex !important;
    flex-direction: row !important;
  }
  .review-steps-custom .ant-steps-item-icon {
    width: 25px !important;
    height: 25px !important;
    line-height: 24px !important;
    font-size: 14px !important;
    margin-top: 4px;
  }

  .review-steps-custom .ant-steps-item-title {
    font-size: 15px !important;
    line-height: 20px !important;
    margin-left: 6px !important;
    display: inline-block;
    vertical-align: middle;
  }
  .review-steps-custom.ant-steps.ant-steps-horizontal:not(
      .ant-steps-label-vertical
    )
    .ant-steps-item {
    padding-inline-start: 45px !important;
  }
  .review-steps-custom .ant-steps-item-container {
    display: flex !important;
    align-items: center !important;
    padding: 0 4px !important;
  }
  .review-steps-custom.ant-steps.ant-steps-navigation .ant-steps-item::after {
    position: absolute;
    top: calc(50% - 0px);
    inset-inline-start: 100%;
    display: inline-block;
    width: 10px;
    height: 10px;
    border-top: 1px solid rgba(0, 0, 0, 0.25);
    border-bottom: none;
    border-inline-start: none;
    border-inline-end: 1px solid rgba(0, 0, 0, 0.25);
    transform: translateY(-50%) translateX(-50%) rotate(45deg);
    content: "";
  }
  .urban-billboard-sub-card {
    overflow-x: auto;
    white-space: normal;
  }

  .urban-billboard-sub-card .ant-row {
    min-width: 400px !important;
    white-space: normal;
  }

  .payment-success-container-card {
    width: 90% !important;
  }
  .check-upload-front-back-row {
    gap: 1.5rem !important;
  }
  .total-campaign-total-price-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .urban-billboard-blitz-text {
    font-size: var(--Font-Font-Size-h6, 16px) !important;
  }

  .order-summary-heading {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .order-summary-heading-amount {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  .choose-payment-selector-dropdown.ant-select-dropdown {
    width: 305px !important;
  }
  .review-secure-row {
    padding: 0px !important;
    margin-bottom: 1rem !important;
  }
  .card-expiry-cvv-row.ant-row {
    width: 100% !important;
  }
  .payment-summary-col {
    width: 100% !important;
  }
  .card-input-cvv-field .ant-input:placeholder-shown {
    text-overflow: ellipsis;
    font-size: 18px;
  }
  .urban-billboard-row {
    margin-top: 0rem !important;
  }
  .time-square-row {
    margin-top: 0px !important;
  }
  .time-square-digital-col-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .time-square-digital-price {
    font-size: var(--Font-Font-Size-p, 13px) !important;
  }
  .total-campaign-amount-label-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .balance-amount-text {
    font-size: 14px !important;
  }
  .apply-term-text {
    font-size: 14px !important;
  }
  .amp-store-text {
    font-size: 14px !important;
  }
  .amp-store-highleted {
    font-size: 14px !important;
  }
  .add-another-term-btn-text {
    font-size: 14px !important;
  }
  .term-apply-final-btn-text {
    font-size: 14px !important;
  }
  .remove-all-terms-plan-text {
    font-size: 14px !important;
  }
  .upfront-payment-text {
    font-size: 14px !important;
  }
  .upfront-payment-price-text {
    font-size: 14px !important;
  }
  .proceed-to-payment-btn-text {
    font-size: 14px !important;
  }
  .payment-summary-text {
    font-size: 15px !important;
  }
  .summary-total-amount-header {
    font-size: 14px !important;
  }
  .summary-total-amount {
    font-size: 14px !important;
  }
  .late-charges-will-apply-text {
    font-size: 14px !important;
  }
  .summary-total-pay-now {
    font-size: 14px !important;
  }
  .summary-modify-payment-plan-text {
    font-size: 14px !important;
  }
  .secure-payment-final-btn-text {
    font-size: 14px !important;
  }
  .credit-debit-collapse-component
    .ant-collapse-header
    .ant-collapse-header-text {
    font-size: 15px !important;
  }
  .payment-success-main-text {
    font-size: var(--Font-Font-Size-h5, 18px) !important;
  }
  .payment-success-divider-row {
    width: 100% !important;
  }
}

@media (min-width: 321px) and (max-width: 375px) {
  .review-steps-custom .ant-steps-item-icon {
    width: 25px !important;
    height: 25px !important;
    line-height: 24px !important;
    font-size: 14px !important;
    margin-top: 4px;
  }
  .review-steps-custom.ant-steps.ant-steps-navigation
    .ant-steps-item-container {
    padding-bottom: 0px !important;
  }
  .urban-billboard-sub-card {
    overflow-x: auto;
    white-space: normal;
  }

  .urban-billboard-sub-card .ant-row {
    min-width: 400px !important;
    white-space: normal;
  }
  .complete-campaign-text {
    font-size: var(--Font-Font-Size-h5, 15px) !important;
  }

  .complete-campaign-text-row {
    padding: 15px 0px 15px 0px !important;
    gap: 3%;
    margin-left: 5% !important;
  }
  .back-arrow-payment-main {
    width: 25px !important;
  }
  .order-summary-col {
    margin-inline-start: 0% !important;
  }
  .order-summary-apply-term-row {
    padding: 0px !important;
  }
  .time-square-digital-col-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .time-square-digital-price {
    font-size: var(--Font-Font-Size-p, 13px) !important;
  }
  .total-campaign-amount-label-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .total-campaign-total-price-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .amp-does-not-store-card {
    width: 96% !important;
  }
  .amp-store-text {
    font-size: 14px !important;
  }
  .amp-store-highleted {
    font-size: 14px !important;
  }
  .choose-payment-selector-dropdown.ant-select-dropdown {
    width: 300px !important;
  }
  .payment-due-col {
    width: 100% !important;
  }
  .balance-amount-input-col {
    width: 100% !important;
  }
  .add-another-term-btn-text {
    font-size: 14px !important;
  }
  .term-apply-final-btn-text {
    font-size: 14px !important;
  }
  .upfront-payment-text {
    font-size: var(--Font-Font-Size-p, 15px) !important;
  }
  .summary-total-amount-header {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .summary-total-amount {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .late-charges-will-apply-text {
    font-size: 14px !important;
  }
  .summary-total-pay-now {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .summary-modify-payment-plan-text {
    font-size: 15px !important;
  }
  .secure-payment-final-btn-text {
    font-size: var(--Font-Font-Size-p, 15px) !important;
  }
  .amp-does-not-store-row {
    margin-top: 0px !important;
    margin-left: 0px !important;
    padding: 10px !important;
  }
  .step-2-common-col-1 {
    width: 0% !important;
  }
  .step-2-common-col-2 {
    width: 100% !important;
    margin-top: 15px !important;
  }
  .card-expiry-cvv-row.ant-row {
    width: 100% !important;
  }
  .payment-summary-col {
    width: 100% !important;
  }
  .payment-success-container-card {
    width: 90% !important;
  }
  .payment-success-main-text {
    font-size: var(--Font-Font-Size-h5, 18px) !important;
  }
  .payment-success-divider-row {
    width: 100% !important;
  }
  .success-total-amount-paid-label {
    font-size: 14px !important;
  }
  .success-total-amount-paid-label-value {
    font-size: 14px !important;
  }
  .payment-success-confirmation-email-text {
    font-size: 14px !important;
  }
  .payment-success-go-to-dashboard-row {
    margin-top: 1rem !important;
  }
  .payment-success-download-invoice-btn-text {
    font-size: var(--Font-Font-Size-p, 15px) !important;
  }
  .order-summary-heading {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .order-summary-heading-amount {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  .urban-billboard-blitz-text {
    font-size: var(--Font-Font-Size-h6, 15px) !important;
  }
  .review-secure-row {
    padding: 0px !important;
  }
  .review-steps-custom.ant-steps {
    width: 100% !important;
  }
  .ant-steps.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::after {
    position: relative;
    inset-inline-start: 50%;
    display: block;
    width: 15px;
    height: 15px;
    margin-bottom: 8px;
    text-align: center;
    transform: translateY(-50%) translateX(-50%) rotate(135deg);
  }
  .order-summary-scroll-main-container {
    overflow-y: unset !important;
    max-height: none !important;
  }
  .payment-success-container-card {
    width: 90% !important;
  }
  .check-upload-front-back-row {
    gap: 1.5rem !important;
  }
  .total-campaign-total-price-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .urban-billboard-blitz-text {
    font-size: var(--Font-Font-Size-h6, 15px) !important;
  }

  .order-summary-heading {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .order-summary-heading-amount {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  .choose-payment-selector-dropdown.ant-select-dropdown {
    width: 305px !important;
  }
  .review-secure-row {
    padding: 0px !important;
    margin-bottom: 1rem !important;
  }
  .card-expiry-cvv-row.ant-row {
    width: 100% !important;
  }
  .payment-summary-col {
    width: 100% !important;
  }
  .card-input-cvv-field .ant-input:placeholder-shown {
    text-overflow: ellipsis;
    font-size: 18px;
  }
  .urban-billboard-row {
    margin-top: 0rem !important;
  }
  .time-square-row {
    margin-top: 0px !important;
  }
  .time-square-digital-col-text {
    font-size: var(--Font-Font-Size-p, 13px) !important;
  }
  .time-square-digital-price {
    font-size: var(--Font-Font-Size-p, 13px) !important;
  }
  .total-campaign-amount-label-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .balance-amount-text {
    font-size: 14px !important;
  }
  .apply-term-text {
    font-size: 14px !important;
  }
  .amp-store-text {
    font-size: 14px !important;
  }
  .amp-store-highleted {
    font-size: 14px !important;
  }
  .add-another-term-btn-text {
    font-size: 14px !important;
  }
  .term-apply-final-btn-text {
    font-size: 14px !important;
  }
  .remove-all-terms-plan-text {
    font-size: 14px !important;
  }
  .upfront-payment-text {
    font-size: 14px !important;
  }
  .upfront-payment-price-text {
    font-size: 14px !important;
  }
  .proceed-to-payment-btn-text {
    font-size: 14px !important;
  }
  .payment-summary-text {
    font-size: 15px !important;
  }
  .summary-total-amount-header {
    font-size: 14px !important;
  }
  .summary-total-amount {
    font-size: 14px !important;
  }
  .late-charges-will-apply-text {
    font-size: 14px !important;
  }
  .summary-total-pay-now {
    font-size: 14px !important;
  }
  .summary-modify-payment-plan-text {
    font-size: 14px !important;
  }
  .secure-payment-final-btn-text {
    font-size: 14px !important;
  }
  .credit-debit-collapse-component
    .ant-collapse-header
    .ant-collapse-header-text {
    font-size: 15px !important;
  }
  .payment-success-main-text {
    font-size: var(--Font-Font-Size-h5, 18px) !important;
  }
  .payment-success-divider-row {
    width: 100% !important;
  }
  .products-title-col {
    max-width: 60%;
    display: flex;
    align-items: center;
  }
}
@media (min-width: 0px) and (max-width: 320px) {
  .products-title-col {
    max-width: 60%;
    display: flex;
    align-items: center;
  }
  .urban-billboard-sub-card {
    overflow-x: auto;
    white-space: normal;
  }

  .urban-billboard-sub-card .ant-row {
    min-width: 400px !important;
    white-space: normal;
  }
  .complete-campaign-text-row {
    padding: 15px 0px 15px 0px !important;
    margin-inline-start: 4%;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .complete-campaign-text {
    font-size: var(--Font-Font-Size-h5, 13px) !important;
  }
  .back-arrow-payment-main {
    width: 20px !important;
  }
  .order-summary-col {
    margin-inline-start: 0% !important;
  }
  .review-steps-custom.ant-steps {
    margin-top: 0px !important;
  }
  .review-secure-row {
    padding: 0px !important;
  }
  .order-summary-col {
    padding: 0px !important;
  }
  .upfront-text-label-name {
    font-size: var(--Font-Font-Size-small, 12px) !important;
  }
  .time-square-digital-price {
    font-size: var(--Font-Font-Size-p, 12px) !important;
  }
  .time-square-digital-col-text {
    font-size: var(--Font-Font-Size-p, 12px) !important;
  }
  .total-campaign-amount-label-text {
    font-size: var(--Font-Font-Size-p, 12px) !important;
  }
  .total-campaign-total-price-text {
    font-size: var(--Font-Font-Size-p, 12px) !important;
  }
  .amp-store-text {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .amp-store-highleted {
    font-size: 14px !important;
    line-height: 20px !important;
  }
  .balance-amount-text {
    font-size: 15px !important;
  }
  .balance-amount-input-col {
    width: 100% !important;
  }
  .payment-due-col {
    width: 100% !important;
  }
  .add-another-term-row {
    flex-wrap: wrap !important;
  }
  .add-another-term-col {
    margin-bottom: 10px !important;
    margin-top: 10px !important;
  }
  .upfront-payment-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .upfront-payment-price-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .term-apply-final-btn-text {
    font-size: 14px !important;
  }
  .proceed-to-payment-btn-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .remove-all-terms-plan-text {
    font-size: 14px !important;
  }
  .add-another-term-btn-text {
    font-size: 15px !important;
  }
  .proceed-to-payment-btn {
    height: 40px !important;
  }
  .payment-summary-text {
    font-size: var(--Font-Font-Size-h6, 17px) !important;
  }
  .summary-total-amount {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .summary-total-amount-header {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .late-charges-will-apply-text {
    font-size: 14px !important;
    line-height: 15.5px !important;
  }
  .summary-total-pay-now {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .summary-modify-payment-plan-text {
    font-size: 14px !important;
  }
  .secure-payment-final-btn {
    height: 40px !important;
  }
  .secure-payment-final-btn-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .amp-does-not-store-row {
    margin-top: 1.2rem !important;
  }
  .step-2-common-col-1 {
    width: 0% !important;
  }
  .step-2-common-col-2 {
    width: 100% !important;
  }
  .amp-does-not-store-row {
    margin-top: 0px !important;
    margin-left: 0px !important;
    padding: 10px !important;
  }
  .card-expiry-cvv-row.ant-row {
    width: 100% !important;
    gap: 0rem !important;
  }
  .card-expiry-number-col {
    width: 100% !important;
  }
  .card-expiry-month-col {
    width: 100% !important;
  }
  .payment-summary-col {
    width: 100% !important;
  }
  .review-secure-row {
    padding: 0px !important;
  }
  .review-steps-custom.ant-steps {
    width: 100% !important;
  }
  .order-summary-scroll-main-container {
    overflow-y: unset !important;
    max-height: none !important;
  }
  .payment-success-container-card {
    width: 90% !important;
  }
  .check-upload-front-back-row {
    gap: 1.5rem !important;
  }
  .total-campaign-total-price-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .urban-billboard-blitz-text {
    font-size: var(--Font-Font-Size-h6, 15px) !important;
  }

  .order-summary-heading {
    font-size: 16px !important;
    font-weight: 600 !important;
  }
  .order-summary-heading-amount {
    font-size: 14px !important;
    font-weight: 600 !important;
  }
  .choose-payment-selector-dropdown.ant-select-dropdown {
    width: 305px !important;
  }
  .review-secure-row {
    padding: 0px !important;
    margin-bottom: 1rem !important;
  }
  .card-expiry-cvv-row.ant-row {
    width: 100% !important;
  }
  .payment-summary-col {
    width: 100% !important;
  }
  .card-input-cvv-field .ant-input:placeholder-shown {
    text-overflow: ellipsis;
    font-size: 18px;
  }
  .urban-billboard-row {
    margin-top: 0rem !important;
  }
  .time-square-row {
    margin-top: 0px !important;
  }
  .time-square-digital-col-text {
    font-size: var(--Font-Font-Size-p, 13px) !important;
  }
  .time-square-digital-price {
    font-size: var(--Font-Font-Size-p, 13px) !important;
  }
  .total-campaign-amount-label-text {
    font-size: var(--Font-Font-Size-p, 14px) !important;
  }
  .balance-amount-text {
    font-size: 14px !important;
  }
  .apply-term-text {
    font-size: 14px !important;
  }
  .amp-store-text {
    font-size: 14px !important;
  }
  .amp-store-highleted {
    font-size: 14px !important;
  }
  .add-another-term-btn-text {
    font-size: 14px !important;
  }
  .term-apply-final-btn-text {
    font-size: 14px !important;
  }
  .remove-all-terms-plan-text {
    font-size: 14px !important;
  }
  .upfront-payment-text {
    font-size: 14px !important;
  }
  .upfront-payment-price-text {
    font-size: 14px !important;
  }
  .proceed-to-payment-btn-text {
    font-size: 14px !important;
  }
  .payment-summary-text {
    font-size: 15px !important;
  }
  .summary-total-amount-header {
    font-size: 14px !important;
  }
  .summary-total-amount {
    font-size: 14px !important;
  }
  .late-charges-will-apply-text {
    font-size: 14px !important;
  }
  .summary-total-pay-now {
    font-size: 14px !important;
  }
  .summary-modify-payment-plan-text {
    font-size: 14px !important;
  }
  .secure-payment-final-btn-text {
    font-size: 14px !important;
  }
  .credit-debit-collapse-component
    .ant-collapse-header
    .ant-collapse-header-text {
    font-size: 15px !important;
  }
  .payment-success-main-text {
    font-size: var(--Font-Font-Size-h5, 18px) !important;
  }
  .payment-success-divider-row {
    width: 100% !important;
  }
  .ant-steps.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::after {
    position: relative;
    inset-inline-start: 50%;
    display: block;
    width: 15px;
    height: 15px;
    margin-bottom: 8px;
    text-align: center;
    transform: translateY(-50%) translateX(-50%) rotate(135deg);
  }
}
@media (max-width: 768px) {
  .purchase-main-component {
    overflow-x: hidden !important;
  }
  .scrollable-content {
    overflow-x: hidden !important;
  }
  .payment-success-container-card {
    width: 60%;
    background: #ffffff;
    box-shadow: 0px 236px 66px 0px #00000000;
  }
}
.review-steps-custom.ant-steps.ant-steps-vertical
  > .ant-steps-item
  .ant-steps-item-content {
  display: block;
  min-height: 24px !important;
  overflow: hidden;
}
.payment-terms-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.payment-terms-row {
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
}

.payment-term-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 5px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 400;
}

.payment-term-upfront {
  background: #fff1f3;
  color: #d2042d;
}

.payment-term-installment {
  background: #f2f4f7;
  color: #475467;
}

.payment-term-date {
  color: #667085;
  font-size: 12px;
}

.payment-term-percentage {
  color: #667085;
  font-size: 12px;
}
.payment-term-amount-new {
  color: #101828;
  font-size: 12px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/features/BuyerFlow/payments-pages/CampaignPayments.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,UAAU;AACZ;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;;;;EAIE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,yCAAyC;EACzC,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,uCAAuC;AACzC;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,4BAA4B;EAC5B,kDAAkD;EAClD,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iDAAiD;EACjD,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAsB;AACxB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;EAEE,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;;;;EAIE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAW;AACb;AACA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,iDAAiD;EACjD,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;AACA;EACE,iDAAiD;EACjD,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;;EAEE,6BAA6B;EAC7B,4CAA4C;EAC5C,UAAU;EACV,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,cAAc;EACd,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,iCAAiC;AACnC;;AAEA;;;EAGE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;AACpD;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA,kBAAkB;;AAElB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,SAAO;AACT;AACA;;EAEE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,wDAAwD;EACxD,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,aAAa;EACb,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,6BAA6B;EAC7B,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,WAAW;EACX,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8CAA8C;AAChD;AACA;EACE,yDAAyD;EACzD,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,yCAAyC;EACzC,6BAA6B;EAC7B,8BAA8B;EAC9B,eAAe;AACjB;AACA;;;EAGE,+BAA+B;EAC/B,mBAAmB;EACnB;;cAEY;AACd;AACA;EACE,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,8CAA8C;AAChD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;AACA;;;;EAIE,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE;IACE,gCAAgC;IAChC,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;GACC,oBAAoB;EACrB;AACF;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,uCAAuC;EACzC;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,oDAAoD;EACtD;EACA;;;IAGE,oDAAoD;EACtD;EACA;IACE,YAAY;EACd;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,oDAAoD;EACtD;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,uCAAuC;EACzC;EACA;IACE,sCAAsC;EACxC;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,0BAA0B;IAC1B,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,cAAc;EAChB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,uBAAuB;IACvB,uCAAuC;EACzC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,qCAAqC;IACrC,oCAAoC;IACpC,oBAAoB;EACtB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,2BAA2B;IAC3B,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,oBAAoB;EACtB;EACA;IACE,WAAW;EACb;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE;IACE,sCAAsC;EACxC;EACA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,kBAAkB;IAClB,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,kCAAkC;EACpC;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;EAChC;EACA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,qBAAqB;IACrB,sBAAsB;EACxB;EACA;;;;IAIE,qCAAqC;EACvC;EACA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,kBAAkB;IAClB,oBAAoB;IACpB,wBAAwB;IACxB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;IACnB,yBAAyB;IACzB,gDAAgD;IAChD,0DAA0D;IAC1D,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,oDAAoD;EACtD;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;EACjB;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,oDAAoD;EACtD;;EAEA;IACE,qCAAqC;IACrC,OAAO;IACP,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,qBAAqB;EACvB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,oDAAoD;EACtD;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,2DAA2D;EAC7D;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,oDAAoD;EACtD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;EACrB;AACF;AACA;EACE;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;EACA;IACE,qCAAqC;IACrC,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kCAAkC;EACpC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uDAAuD;EACzD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;IAC9B,2BAA2B;EAC7B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oDAAoD;EACtD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;IAC1B,8BAA8B;EAChC;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,mDAAmD;EACrD;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,mDAAmD;EACrD;EACA;IACE,oDAAoD;EACtD;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,uBAAuB;IACvB,8BAA8B;EAChC;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;IACvB,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,mDAAmD;EACrD;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;EACA;;;IAGE,0BAA0B;EAC5B;EACA;IACE,oDAAoD;EACtD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,2DAA2D;EAC7D;AACF;AACA;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,mBAAmB;IACnB,wCAAwC;EAC1C;AACF;AACA;;;EAGE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".purchase-main-component {\n  background: #f5f5f5;\n  width: 100%;\n  /* height: 90vh; */\n  overflow: hidden;\n}\n\n.complete-campaign-text-row {\n  display: flex;\n  border-bottom: 1px solid #d2d2d2;\n  background: #f5f5f5;\n  padding: 10px 0px 31px 74px;\n  align-items: center;\n  flex-shrink: 0;\n  gap: 2%;\n  position: sticky;\n}\n.step-padding-depend-step-class {\n  padding: 10px 0px 31px 345px !important;\n}\n.step-padding-depend-step-class-bread {\n  padding-left: 345px !important;\n}\n.complete-campaign-text-row-bread {\n  padding-left: 75px;\n  padding-top: 15px;\n}\n.complete-campaign-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n\n.review-secure-row {\n  display: flex;\n  align-items: center;\n  gap: 19px;\n  padding: 20px;\n}\n.review-steps-custom.ant-steps .ant-steps-item-process .ant-steps-item-icon {\n  background-color: #d2042d;\n  border-color: #d2042d;\n}\n.review-steps-custom.ant-steps {\n  width: 20%;\n}\n.review-steps-custom .ant-steps-item::before {\n  background-color: transparent !important;\n}\n.review-steps-custom.ant-steps .ant-steps-item-finish .ant-steps-item-icon {\n  background-color: #d2042d !important;\n  border-color: #d2042d !important;\n}\n.review-steps-custom.ant-steps\n  .ant-steps-item-finish\n  .ant-steps-item-icon\n  > .ant-steps-icon {\n  color: white !important;\n}\n\n.ant-steps-item-title:hover {\n  cursor: pointer;\n}\n\n.order-summary-apply-term-row {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0px 15px;\n  margin-left: 0px !important;\n}\n.card-summary-card {\n  width: 100%;\n  height: auto;\n  flex-shrink: 0;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.amp-note-store-card {\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n.amp-note-store-card.ant-card .ant-card-body {\n  width: 100%;\n  padding-top: 24px !important;\n}\n\n.order-summary-heading {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: 23px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 24px;\n}\n.order-summary-heading-amount {\n  font-family: Roboto;\n  font-weight: 600;\n  font-style: SemiBold;\n  font-size: 20px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Primary-500, #d2042d);\n}\n.order-summary-scroll-main-container {\n  overflow-y: auto;\n  max-height: 530px;\n  padding: 10px !important;\n}\n.payments-campaign-id {\n  color: var(--Colors-Text-400, #3b3f3d);\n  font-family: Roboto;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 1.5rem;\n}\n\n.urban-billboard-blitz-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  text-decoration: underline;\n  margin-right: 10px;\n  cursor: pointer;\n}\n.urban-billboard-sub-card {\n  border-radius: 5px;\n  background: #f7f7f7;\n  margin-top: 15px;\n}\n.urban-billboard-sub-card.ant-card .ant-card-body {\n  padding-top: 15px !important;\n  border-radius: 0 0 8px 8px;\n}\n.products-text-non {\n  color: var(--Colors-Text-200, #8e9190);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.campaigns-upfront-products-row {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  flex-wrap: nowrap;\n}\n.upfront-text-label-name {\n  color: var(--Colors-Secondary-500, #8e9190);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.time-square-row {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: space-between;\n  margin-top: 16px;\n  flex-wrap: nowrap;\n}\n\n.products-title-col {\n  max-width: 70%;\n  display: flex;\n  align-items: center;\n}\n.products-title-col-value {\n  width: 75%;\n  display: flex;\n  justify-content: flex-end;\n}\n.total-campaign-total-price-col {\n  width: 25%;\n  display: flex;\n  justify-content: flex-end;\n}\n.collapse-arrow-mark {\n  width: 10px !important;\n  height: 16px !important;\n  margin-right: 10px !important;\n  cursor: pointer;\n}\n.product-count-collapse {\n  color: var(--Colors-Text-200, #8e9190);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.waiting-for-approval-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 14px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Primary-300, #e15772);\n}\n.approved-text-color {\n  color: #008342 !important;\n  font-size: 14px !important;\n}\n.rejected-text-color {\n  color: #d2042d;\n  font-size: 14px !important;\n}\n.withdraw-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-style: Medium;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  color: var(--Colors-Primary-500, #d2042d);\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  margin-top: 10px;\n}\n.collapse-arrow-mark.open {\n  transform: rotate(90deg);\n  transition: transform 0.3s ease;\n}\n\n.time-square-digital-col-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-right: 10px;\n}\n.time-square-digital-price {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.offer-applied-cost-price {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.offer-applied-text {\n  color: var(--Colors-Secondary-500, #008342);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.down-town-static-row {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1.5rem;\n}\n.total-campaign-row,\n.draw-help-col {\n  display: flex;\n  justify-content: space-between;\n}\n.draw-help-col {\n  margin-top: 18px;\n}\n.draw-text {\n  color: #5b5e5d;\n}\n.sign-help-text {\n  font-weight: 400;\n  font-size: 16px;\n}\n.total-campaign-amount-label-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.campaign-diver.ant-divider-horizontal {\n  height: 0px;\n  flex-shrink: 0;\n  stroke-width: 1px;\n  stroke: var(--Colors-Text-300, #5b5e5d);\n}\n.total-campaign-total-price-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.total-campaign-total-price-text-default {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.apply-term-text {\n  color: #000;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.terms-withdrawn-row {\n  display: flex;\n  gap: 10px;\n}\n.withdrawn-text-badge {\n  background-color: #d2042d;\n  border-radius: 4px;\n  padding: 2px;\n}\n.withdrawn-text {\n  color: white !important;\n}\n\n.downout-lined-icon {\n  width: 16px !important;\n  height: 8px !important;\n  stroke-width: 2px !important;\n  stroke: var(--Colors-Text-500, #0a0f0d) !important;\n  cursor: pointer !important;\n}\n.balance-amount-row {\n  margin-top: 2%;\n}\n.balance-amount-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.payment-due-row {\n  align-items: center;\n  width: 100%;\n  margin-top: 5%;\n}\n.payment-due-col {\n  width: 50%;\n}\n.balance-amount-input-col {\n  width: 50%;\n}\n.highlighted-balance-col {\n  width: 45%;\n}\n.delete-icon-col {\n  width: 5%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n.delete-icon-another-term {\n  cursor: pointer;\n  width: 24px !important;\n  height: 24px !important;\n  aspect-ratio: 1/1;\n}\n.delete-icon-another-term.delete-disabled {\n  cursor: not-allowed !important;\n  opacity: 0.4;\n  pointer-events: none;\n}\n.delete-icon-another-term:hover {\n  opacity: 0.7;\n}\n\n.delete-icon-col:hover {\n  background-color: #d2d2d2;\n  border-radius: 50%;\n  transition: background-color 0.3s ease;\n  padding: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.choose-payment-selector-component {\n  width: 100%;\n  height: 40px;\n}\n.choose-payment-selector-component .ant-select-selection-placeholder {\n  color: var(--Colors-Text-200, #8e9190) !important;\n  font-family: Roboto !important;\n  font-size: 13px !important;\n  font-style: normal;\n  font-weight: 400 !important;\n  line-height: 24px !important;\n  flex: 1 0 0 !important;\n}\n.choose-payment-selector-dropdown.ant-select-dropdown {\n  width: 370px !important;\n}\n.choose-payment-select-options {\n  display: flex;\n  width: 100%;\n  padding: 10px;\n  flex-direction: column;\n  align-items: flex-start;\n  border-radius: 3px;\n  background: #fff;\n}\n\n.choose-payment-selector-dropdown .choose-payment-select-options {\n  padding: 8px;\n  border-radius: 6px;\n  transition: background-color 0.3s;\n}\n\n.choose-payment-selector-dropdown .choose-payment-select-options:hover {\n  background-color: #d2042d;\n  color: #fff;\n}\n\n.choose-payment-selector-dropdown\n  .choose-payment-select-options:hover\n  .choose-payment-select-label,\n.choose-payment-selector-dropdown\n  .choose-payment-select-options:hover\n  .choose-payment-select-description {\n  color: #fff;\n}\n\n.choose-payment-selector-dropdown\n  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n  background-color: transparent !important;\n}\n.choose-payment-select-label {\n  align-self: stretch;\n  color: #000;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.choose-payment-select-description {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.add-another-term-row {\n  margin-top: 5%;\n  width: 100%;\n  margin-top: 5%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: space-between;\n  align-items: center;\n}\n.add-another-term-col {\n  width: 100%;\n}\n\n.add-another-term-btn {\n  width: 100%;\n}\n.add-icon {\n  display: flex;\n  width: 20px;\n  height: auto;\n}\n.add-another-term-btn-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.add-another-term-btn-text:hover {\n  text-decoration: underline !important;\n}\n.choose-payment-selector-component.ant-select-outlined:not(\n    .ant-select-customize-input\n  )\n  .ant-select-selector {\n  border: none !important;\n  background: #f5f5f5;\n}\n.choose-payment-selector-component.ant-select .ant-select-arrow {\n  color: #000 !important;\n}\n.remove-all-term-plan-row {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n.remove-all-terms-plan-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: none;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n}\n.add-more-money-card {\n  display: flex;\n  padding: 25px 25px 25px 25px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  margin-top: 2%;\n}\n.add-more-money-optional-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.enter-amount-label-row {\n  width: 100%;\n  margin-top: 10%;\n}\n.dollar-icon-enter-amount {\n  color: var(--Colors-Background-100, #fcfcfc);\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n.enter-amount-label .ant-input-group-addon {\n  align-items: center;\n  background: var(--Colors-Text-500, #0a0f0d);\n}\n.enter-amount-custom-input input {\n  color: var(--Colors-Text-200, #8e9190);\n  font-family: Roboto;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  flex: 1 0 0;\n}\n.enter-amount-custom-input .ant-input-group .ant-input-group-addon:last-child {\n  border-start-start-radius: 0;\n  border-end-start-radius: 0;\n  color: var(--Colors-Text-200, #8e9190) !important;\n  font-family: Roboto !important;\n  font-size: 13px !;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n  background-color: #8e9190 !important;\n}\n.enter-amount-custom-input .ant-input-group .ant-input {\n  color: var(--Colors-Text-500, #0a0f0d) !important;\n  font-family: Roboto;\n  font-size: 16px;\n  background-color: #f5f5f5;\n  padding: 4px 4px !important;\n}\n.enter-amount-custom-input:focus,\n.enter-amount-custom-input .ant-input-outlined:focus-within {\n  border-color: #000 !important;\n  box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);\n  outline: 0;\n  background-color: #ffffff;\n}\n.enter-amount-label {\n  display: flex;\n  height: 40px;\n  padding: 10px 0px 10px 0px;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  background: #f5f5f5 !important;\n  width: 100%;\n}\n.proceed-to-payment-card {\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  height: auto;\n  align-self: stretch;\n}\n.proceed-to-payment-row {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 5%;\n}\n.remaining-balance-row {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 5%;\n}\n.upfront-payment-text {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.upfront-payment-price-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.note-apply-condition-row {\n  display: flex;\n  width: 100%;\n  height: auto;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 3px;\n  background: #ffedf1;\n  margin-top: 5%;\n}\n.note-apply-condition-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.proceed-to-payment-button-row {\n  width: 100%;\n  margin-top: 5%;\n  margin-left: 0px !important;\n}\n.proceed-to-payment-btn {\n  display: flex;\n  width: 100%;\n  height: 50px;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  margin-bottom: 1rem;\n}\n.proceed-to-payment-btn:hover {\n  background-color: #d2042d !important;\n  border-color: #d2042d !important;\n  color: #fff !important;\n}\n.proceed-to-checkout:hover {\n  background-color: #d2042d !important;\n  color: white !important;\n  border: none !important;\n}\n.proceed-to-payment-btn-text {\n  color: #fff;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.secure-payment-tab-row {\n  width: 100%;\n  overflow-x: auto;\n  gap: 0.5rem;\n  padding-inline: 4rem;\n}\n.credit-debit-collapse-component {\n  background-color: #fff !important;\n}\n.credit-debit-collapse-component {\n  background-color: #fff !important;\n}\n\n.credit-debit-collapse-component\n  .ant-collapse-header\n  .ant-collapse-header-text {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.credit-debit-collapse-component .ant-collapse-header .ant-collapse-arrow {\n  font-size: larger !important;\n}\n.payment-summary-card {\n  height: auto;\n  align-self: stretch;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n.card-number-field-row {\n  width: 100%;\n  margin-top: 20px;\n}\n.card-details-space {\n  flex-direction: column !important;\n  width: 85% !important;\n}\n.card-number-input-field {\n  display: flex;\n  width: 100%;\n  height: 44px;\n  padding: 10px 20px 10px 14px;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #f5f5f5;\n}\n\n.card-number-input-field.ant-input-filled:hover {\n  border-color: #000000;\n  background-color: #f5f5f5;\n}\n\n.card-number-input-field.ant-input-filled:focus {\n  border-color: #000000;\n  background-color: #f5f5f5;\n  box-shadow: none;\n}\n.card-expiry-cvv-row.ant-row {\n  display: flex !important;\n  gap: 1.5rem !important;\n  align-items: center;\n  width: 85%;\n}\n.card-expiry-month-col {\n  width: 45%;\n}\n.card-input-cvv-field {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  padding: 10px 20px 10px 14px;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #f5f5f5;\n}\n.card-input-cvv-field.ant-input-filled:hover {\n  border-color: #000000;\n  background-color: #f5f5f5;\n}\n.card-input-cvv-field.ant-input-filled:focus {\n  border-color: #000000 !important;\n  background-color: #f5f5f5;\n}\n.card-month-input-field {\n  display: flex;\n  width: 100%;\n  height: 40px;\n  padding: 10px 20px 10px 14px;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #f5f5f5;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n/* CardInput.css */\n\n.card-element-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  border-radius: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  cursor: pointer;\n  background-color: #f5f5f5;\n  margin-bottom: 20px;\n}\n.card-element-wrapper.active {\n  border-color: #000000 !important;\n}\n.card-element-inner {\n  flex: 1;\n}\n.payment-select-country.ant-select-single.ant-select-show-arrow\n  .ant-select-selection-item {\n  font-size: 14px !important;\n  color: #000000 !important;\n}\n.payment-select-country {\n  width: 100%;\n  height: 2.5rem;\n  align-items: center;\n  border-radius: 0.3125rem;\n  border-bottom: 1px solid var(--Colors-Text-400, #3b3f3d);\n  background: #f5f5f5;\n  padding-top: 0px !important;\n}\n.payment-select-country.with-padding {\n  padding-top: 1rem !important;\n}\n.payment-select-country .ant-select-selector {\n  border: none !important;\n  background: #f5f5f5 !important;\n}\n.card-month-input-field.ant-input-filled:hover {\n  border-color: #000000;\n  background-color: #f5f5f5;\n}\n.card-month-input-field.ant-input-filled:focus {\n  border-color: #000000;\n  background-color: #f5f5f5;\n}\n\n.card-expiry-number-col {\n  width: 45%;\n}\n.save-card-future-row {\n  display: flex;\n  gap: 2%;\n  margin-top: 1.5rem;\n  width: 100%;\n}\n.save-card-future-text {\n  color: #000;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.card-details-secured-row {\n  display: flex;\n  margin-top: 1rem;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n.card-details-secured-container {\n  display: flex;\n  width: 100%;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 5px;\n  background: #ffecf0;\n}\n.card-details-secured-text {\n  color: #d2042d;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.accepted-card-row {\n  display: flex;\n  margin-top: 1.2rem;\n}\n.accepted-card-text {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.cards-maintaing-component {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  align-content: flex-start;\n  margin-top: 1rem;\n  gap: 1rem;\n}\n.pay-by-check-main-container {\n  width: 100%;\n  height: auto;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n}\n.check-upload-container {\n  text-align: center;\n  border-radius: 0.625rem;\n  border: 2px dashed #d2042d;\n  width: 100%;\n  height: 166px;\n  background: #fff4f6;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.check-upload-submitted {\n  text-align: center;\n  /* border-radius: 0.625rem; */\n  border: none !important;\n  width: 100%;\n  height: 166px;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n.final-check-images-row {\n  width: 100%;\n  display: flex;\n  height: 100%;\n}\n.final-check-images-front-col {\n  width: 50%;\n}\n.final-check-images-back-col {\n  width: 50%;\n}\n.uploaded-image {\n  width: 90% !important;\n  height: 122px !important;\n}\n.final-check-review-confirm {\n  display: flex;\n  flex-direction: column;\n  align-content: flex-start;\n  justify-content: center;\n  align-items: flex-start;\n  margin-top: 2rem;\n}\n.check-review-confirm {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000;\n}\n.check-user-details {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-400, #3b3f3d);\n}\n.view-more-details-container-check {\n  display: flex;\n  justify-content: center;\n  margin-top: 2rem;\n}\n.view-more-details-container-check-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  color: #d2042d;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  cursor: pointer;\n}\n.base-text-under-view-details {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-300, #5b5e5d);\n  margin-top: 2rem;\n}\n.check-upload-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: Font/Font Size/p;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  cursor: pointer;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  color: #d2042d;\n}\n.check-front-view-text-row {\n  display: flex;\n  margin-bottom: 1rem;\n  flex-direction: row;\n  align-content: center;\n  justify-content: flex-start;\n  margin-bottom: 1rem;\n}\n.check-front-view-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #000000;\n}\n.check-upload-section-text-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n.check-upload-modal.ant-modal .ant-modal-title {\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 100%;\n}\n.check-upload-modal.ant-modal {\n  width: 900px !important;\n}\n.check-upload-front-back-row {\n  width: 100%;\n  height: auto;\n  display: flex;\n  justify-content: center;\n  gap: 4%;\n  margin-top: 2rem;\n}\n.check-upload-front-col {\n  width: 48%;\n}\n.check-upload-back-col {\n  width: 48%;\n}\n.check-instructions-row {\n  display: flex;\n  margin-top: 1rem;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: flex-start;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.check-instructions-list.ant-list .ant-list-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0px 0;\n  color: rgba(0, 0, 0, 0.88);\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n}\n.check-user-details-container {\n  display: flex;\n  width: 100%;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n.sample-check-image-container {\n  width: 100% !important;\n  margin-top: 1rem;\n}\n.check-user-details-common-col.ant-col {\n  width: 35% !important;\n}\n.check-image-wrapper {\n  position: relative;\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n.check-close-icon {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n  z-index: 1;\n  background: #fff;\n  border-radius: 50%;\n  padding: 2px;\n}\n.demo-check-image.ant-image .ant-image-img {\n  width: 100% !important;\n  height: 100% !important;\n  border-radius: 0.5rem !important;\n}\n.sample-check-image-container .ant-image {\n  position: relative;\n  display: inline-block;\n  width: 100% !important;\n  height: 100% !important;\n}\n.check-footer-text-links {\n  cursor: pointer;\n  font-family: Roboto;\n  font-weight: 500;\n  color: var(--Colors-Primary-500, #d2042d);\n  font-size: 13px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n}\n.check-image-card {\n  display: flex;\n  /* padding: 25px 25px 25px 25px; */\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 16px;\n  align-self: stretch;\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n  margin-top: 2%;\n}\n.check-image-card.ant-card .ant-card-body {\n  padding-top: 15px !important;\n  border-radius: 0 0 8px 8px;\n}\n.check-custom-cancel-button {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  background: #e0e0e0;\n  color: #000;\n}\n.check-custom-cancel-button:hover,\n.check-custom-cancel-button:focus {\n  background-color: #e0e0e0 !important;\n  color: #000 !important;\n  border-color: #e0e0e0 !important;\n}\n.check-custom-ok-button {\n  background: #d2042d;\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n.payment-summary-col {\n  width: 25%;\n  height: auto;\n}\n.payment-summary-text {\n  color: #000;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.common-summary-row {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 10px;\n}\n.common-summary-col {\n  width: 60%;\n}\n.summary-total-amount-header {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.summary-total-amount {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.summary-applied-term-plan-row {\n  margin-top: 2rem;\n}\n.summary-applied-term-plan {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-small, 13px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.summary-total-pay-now {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.summary-modify-payment-plan-row {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  margin-top: 1.8rem;\n}\n.summary-modify-payment-plan-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: auto;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  cursor: pointer;\n}\n.secure-payment-final-btn {\n  display: flex;\n  width: 100%;\n  height: 50px;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n  margin-top: 1rem;\n}\n.secure-payment-final-btn:hover {\n  background-color: #d2042d !important;\n  border-color: #d2042d !important;\n}\n.secure-payment-final-btn-text {\n  color: #fff;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.payment-success-container-div {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  margin-top: 7%;\n}\n.payment-success-container-card {\n  width: 25%;\n  background: #ffffff;\n  box-shadow: 0px 236px 66px 0px #00000000;\n}\n.payment-success-icon-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.payment-success-main-text-col {\n  margin-top: 10px;\n}\n.payment-success-main-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-h5, 23px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.payment-success-divider-row {\n  display: flex;\n  justify-content: center;\n  width: 80%;\n}\n.success-total-amount-paid-row {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  justify-content: space-between;\n  margin-top: 2rem;\n}\n.common-success-total-amount-col {\n  width: 50%;\n}\n.common-success-total-amount-col-campaign {\n  width: 50%;\n  display: flex;\n  flex-direction: column;\n  align-content: center;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.success-total-amount-paid-label {\n  color: var(--Colors-Text-200, #8e9190);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.success-total-amount-paid-label-value {\n  color: var(--Colors-Text-500, #0a0f0d);\n  text-align: right;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n.payment-success-confirmation-email-row {\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  margin-top: 0.5rem;\n}\n.payment-success-confirmation-email-text {\n  color: var(--Colors-Text-300, #5b5e5d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n.payment-success-go-to-dashboard-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1.5rem;\n}\n.payment-success-go-to-dashboard-text {\n  color: var(--Colors-Primary-500, #d2042d);\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  text-decoration-line: underline;\n  text-decoration-style: solid;\n  text-decoration-skip-ink: auto;\n  text-decoration-thickness: auto;\n  text-underline-offset: auto;\n  text-underline-position: from-font;\n  cursor: pointer;\n}\n.payment-success-download-invoice-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n.payment-success-download-invoice-btn {\n  display: flex;\n  width: 100%;\n  height: 50px;\n  padding: 8px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: var(--Colors-Primary-500, #d2042d);\n}\n.payment-success-download-invoice-btn:hover {\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  border-color: #d2042d !important;\n}\n.payment-success-download-invoice-btn-text {\n  color: #fff;\n  font-family: Roboto;\n  font-size: var(--Font-Font-Size-p, 16px);\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n}\n.amp-does-not-store-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 3rem;\n}\n.amp-does-not-store-card.ant-card .ant-card-body {\n  padding-bottom: 0px !important;\n}\n.amp-does-not-store-card-row {\n  display: flex;\n  justify-content: center;\n}\n.amp-does-not-store-card {\n  display: flex;\n  width: 100%;\n  gap: 8px;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n.amp-does-not-store-card-terms {\n  display: flex;\n  width: 100%;\n  gap: 8px;\n  border-radius: 10px;\n  background: #ffffff;\n  box-shadow: 2px 2px 13.1px 0px #0000000d;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n}\n.amp-does-not-store-card-terms.ant-card .ant-card-body {\n  padding-bottom: 0px !important;\n}\n.amp-store-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  text-align: center;\n  color: #000000;\n}\n.amp-store-highleted {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  color: var(--Colors-Primary-500, #d2042d);\n  text-decoration-thickness: 0%;\n  text-decoration-skip-ink: auto;\n  cursor: pointer;\n}\n.review-steps-custom.ant-steps\n  .ant-steps-item-container:focus-visible\n  .ant-steps-item-icon {\n  outline: transparent !important;\n  outline-offset: 1px;\n  transition:\n    outline-offset 0s,\n    outline 0s;\n}\n.payments-empty-campaigns-container {\n  margin-top: 0px !important;\n  width: 100% !important;\n}\n.step-2-common-col-1 {\n  width: 20%;\n}\n.step-2-common-col-2 {\n  width: 60%;\n}\n.step-2-common-col-3 {\n  width: 20%;\n  display: flex;\n  justify-content: center;\n}\n.term-apply-final-btn-text {\n  color: #fff;\n  font-family: Roboto;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.term-apply-final-btn {\n  display: flex;\n  width: 100%;\n  padding: 0.5rem 1.25rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n  border-radius: 0.3125rem;\n  background: #d2042d;\n}\n.term-apply-final-btn:hover {\n  background: #d2042d !important;\n}\n.term-apply-final-btn.ant-btn-variant-solid:disabled {\n  background: #d2042d !important;\n}\n.btn-disabled-parent .term-apply-final-btn {\n  cursor: not-allowed !important;\n  border-color: #d9d9d9 !important;\n  color: #fff !important;\n  background: #d2042d !important;\n  box-shadow: none !important;\n}\n.remove-user-term-btn {\n  height: 40px;\n  padding: 8px 20px;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  border: 1px solid #000;\n  background: #fff;\n}\n.remove-user-term-btn:hover {\n  border-color: #000 !important;\n  color: #0a0f0d !important;\n}\n.remove-user-term-btn-text {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.complete-to-payment-btn {\n  height: 40px;\n  padding: 8px 20px;\n  gap: 8px;\n  flex-shrink: 0;\n  border-radius: 5px;\n  background: #d2042d !important;\n}\n.complete-to-payment-btn-text {\n  color: #fff;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n.terms-user-warning-modal .ant-modal-title {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h6, 19px);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.text-to-continue-or-remove {\n  color: #000;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n.next-to-terms-version {\n  width: 100%;\n  height: 45px;\n  gap: 8px;\n  border-radius: 5px;\n  padding: 8px;\n  background: var(--Colors-Primary-500, #d2042d);\n  margin-top: 1rem;\n  cursor: pointer;\n}\n.next-to-terms-version:hover {\n  background-color: #d2042d !important;\n  color: #ffffff !important;\n}\n.next-to-terms-version-text.ant-typography {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #ffffff;\n}\n.back-arrow-payment-main {\n  cursor: pointer;\n}\n.upout-lined-icon {\n  cursor: pointer;\n}\n.late-charges-will-apply {\n  width: 100%;\n  height: 55;\n  border-radius: 5px;\n  padding-top: 8px;\n  padding-right: 14px;\n  padding-bottom: 8px;\n  padding-left: 14px;\n  gap: 8px;\n  background: #ffecf0;\n}\n.late-charges-will-apply-text {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19.5px;\n  letter-spacing: 0%;\n}\n.check-payment-main-container {\n  background: #f5f5f5;\n  width: 100%;\n  overflow-x: hidden;\n}\n.check-payments-button-version-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 1rem;\n}\n.check-payments-button-version-cancel.ant-btn-variant-solid {\n  background: #f0f0f0 !important;\n  border-radius: 5px;\n  padding-top: 8px;\n  padding-right: 34px;\n  padding-bottom: 8px;\n  padding-left: 34px;\n  width: 100%;\n  height: 40px;\n}\n.check-payments-button-version-cancel.ant-btn-primary:hover {\n  background-color: #f0f0f0 !important ;\n}\n.check-payments-button-version-cancel-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--Colors-Text-500, #0a0f0d);\n}\n.check-payments-button-version-submit {\n  height: 40px;\n  border-radius: 5px;\n  padding-top: 8px;\n  padding-right: 34px;\n  padding-bottom: 8px;\n  padding-left: 34px;\n  width: 100%;\n  background: var(--Colors-Primary-500, #d2042d);\n}\n.check-payments-button-version-submit:hover {\n  background-color: #d2042d !important;\n}\n.check-payments-button-version-submit-text {\n  font-family: Roboto;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #fff;\n}\n.check-instructions-list.ant-list {\n  padding: 10px !important;\n}\n.displaying-total-campaigns-card {\n  display: flex;\n  width: 100%;\n}\n.review-steps-custom.ant-steps.ant-steps-navigation\n  .ant-steps-item-container:hover {\n  color: #8e9190 !important;\n}\n.empty-box-payments {\n  margin-bottom: 3rem !important;\n}\n.review-steps-custom.ant-steps.ant-steps-navigation\n  .ant-steps-item-container\n  .ant-steps-item-title {\n  max-width: 100% !important;\n  padding-inline-end: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  margin-right: 10px !important;\n  font-weight: 700;\n  font-size: 16px;\n}\n.review-steps-custom.ant-steps.ant-steps-horizontal:not(\n    .ant-steps-label-vertical\n  )\n  .ant-steps-item {\n  padding-inline-start: 32px !important;\n  white-space: nowrap !important;\n}\n.error-campaigns-div {\n  display: flex;\n  flex-direction: column;\n}\n.secure-payment-final-btn.ant-btn-variant-outlined:disabled {\n  background-color: #d2042d !important;\n}\n.secure-payment-final-btn:hover {\n  background-color: #910621 !important;\n}\n\n.io-footer {\n  padding-left: 26px;\n  padding-top: 32px;\n  padding-bottom: 20px;\n  background: #fff;\n  /* width: 64.5vw; */\n  /* display: flex; */\n  align-items: center;\n  font-size: 16px;\n  font-weight: 400;\n  color: #5b5e5d;\n  margin-top: 24px;\n  border-radius: 10px;\n}\n.info-text {\n  width: 70%;\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n.docu-sign-buttons {\n  background: #d2042d !important;\n  color: #fff !important;\n}\n.docu-sign-buttons:hover {\n  border-color: #d2042d !important;\n}\n.continue-btn {\n  display: flex;\n  justify-self: flex-end;\n  right: 3rem;\n}\n.confirm-docusign {\n  padding: 16px 20px;\n  display: flex;\n  justify-self: right;\n}\n.agree-docusign-terms {\n  text-decoration: underline;\n  margin: 0 5px 0 5px;\n}\n.docu-sign-option-container {\n  margin-left: 12px;\n  margin-top: 24px;\n}\n.sign-card {\n  background: #f5f5f5;\n  padding-bottom: 30px;\n}\n.sign-header {\n  margin-bottom: 23px;\n}\n.sign-sub-header {\n  color: #0a0a0a;\n  margin-bottom: 33px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 24px;\n}\n.agreement-title {\n  font-size: 16px;\n  font-weight: 700;\n  margin-bottom: 12px;\n}\n.agreement-content {\n  color: #5b5e5d;\n}\n.signed-label {\n  margin-top: 20px;\n}\n.agreement-button-labels {\n  border: none;\n  pointer-events: none;\n  width: 279px;\n  height: 40px;\n}\n.e-sign-header {\n  margin-top: 32px;\n  margin-bottom: 18px;\n}\n.draw-sign-space {\n  height: 210px;\n  background: #fff;\n  border: 1px dashed #8b8b8b;\n  stroke-dasharray: 12, 6;\n  border-radius: 10px;\n}\n.launch-header {\n  color: #000;\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 6px;\n}\n@media (max-width: 1440px) {\n  .negotiate-assets-table {\n    /* max-width: 80vh !important; */\n    overflow-x: auto;\n  }\n  .negotiate-assets-table .ant-table-tbody > tr > td {\n    white-space: nowrap;\n    word-break: normal;\n  }\n  .secure-payment-tab-row {\n   padding-inline: 0rem;\n  }\n}\n@media (min-width: 1025px) and (max-width: 1440px) {\n  .review-secure-row {\n    padding: 10px !important;\n  }\n  .complete-campaign-text-row {\n    padding: 25px 0px 25px 188px !important;\n  }\n  .time-square-digital-col-text {\n    font-size: var(--Font-Font-Size-p, 16px) !important;\n  }\n  .time-square-digital-price {\n    font-size: var(--Font-Font-Size-p, 16px) !important;\n  }\n  .save-card-future-text {\n    font-size: 15px !important;\n  }\n  .payment-summary-text {\n    font-size: var(--Font-Font-Size-h6, 18px) !important;\n  }\n  .credit-debit-collapse-component\n    .ant-collapse-header\n    .ant-collapse-header-text {\n    font-size: var(--Font-Font-Size-h6, 18px) !important;\n  }\n  .payment-summary-col {\n    height: auto;\n  }\n\n  .review-steps-custom.ant-steps {\n    width: 30% !important;\n  }\n  .urban-billboard-blitz-text {\n    font-size: var(--Font-Font-Size-h6, 18px) !important;\n  }\n  .choose-payment-selector-dropdown\n    .ant-select-single.ant-select-show-arrow\n    .ant-select-selection-placeholder {\n    font-size: 12px !important;\n  }\n  .choose-payment-selector-dropdown.ant-select-dropdown {\n    width: 305px !important;\n  }\n  .enter-amount-custom-input .ant-input-group .ant-input {\n    font-size: 12px !important;\n  }\n  .add-another-term-btn-text {\n    font-size: 14px !important;\n  }\n  .delete-icon-another-term {\n    width: 20px !important;\n    height: 20px !important;\n  }\n  .highlighted-balance-col {\n    width: 43% !important;\n  }\n  .payment-due-col {\n    width: 47% !important;\n  }\n  .add-another-term-btn-icon {\n    width: 14px !important;\n    height: 14px !important;\n  }\n  .add-more-money-card {\n    padding: 0px !important;\n  }\n  .payment-success-container-card {\n    width: 35% !important;\n  }\n}\n@media (min-width: 768px) and (max-width: 850px) {\n  .card-expiry-cvv-row.ant-row {\n    align-items: center;\n    width: 100% !important;\n  }\n}\n@media (min-width: 769px) and (max-width: 1024px) {\n  .review-steps-custom.ant-steps {\n    width: 40% !important;\n  }\n  .complete-campaign-text-row {\n    padding: 25px 0px 25px 100px !important;\n  }\n  .highlight-step {\n    padding: 25px 0px 25px 45px !important;\n  }\n  .review-secure-row {\n    padding: 20px !important;\n  }\n  .urban-billboard-row {\n    margin-top: 0.7rem !important;\n  }\n  .choose-payment-selector-component.ant-select-selection-placeholder {\n    font-size: 12px !important;\n  }\n  .enter-amount-custom-input .ant-input-group .ant-input {\n    font-size: 14px !important;\n  }\n  .choose-payment-selector-component .ant-select-selection-placeholder {\n    font-size: 12px !important;\n  }\n  .order-summary-col {\n    margin-inline-start: 0% !important;\n  }\n  .payment-due-col {\n    width: 47% !important;\n  }\n  .payment-due-responsive .payment-due-col {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: 0 0 100% !important;\n    display: block;\n  }\n  .payment-due-responsive .balance-amount-input-col {\n    width: 100% !important;\n    max-width: 100% !important;\n    flex: 0 0 100% !important;\n    display: block;\n  }\n  .payment-due-responsive .highlighted-balance-col {\n    width: 80% !important;\n    max-width: 80% !important;\n    flex: 0 0 100% !important;\n    display: block;\n  }\n  .payment-due-responsive .delete-icon-col {\n    display: block;\n  }\n  .delete-icon-col {\n    text-align: right;\n    margin-top: 8px;\n  }\n\n  .balance-amount-input-col {\n    margin-top: 8px;\n  }\n  .choose-payment-selector-dropdown.ant-select-dropdown {\n    width: 306px !important;\n    inset: 372px auto auto 596px !important;\n  }\n  .add-more-money-card {\n    padding: 0px !important;\n  }\n  .upfront-payment-text {\n    font-size: 15px !important;\n  }\n  .proceed-to-payment-btn {\n    height: 40px !important;\n  }\n  .proceed-to-payment-btn-text {\n    font-size: var(--Font-Font-Size-p, 15px) !important;\n  }\n  .urban-billboard-blitz-text {\n    font-size: var(--Font-Font-Size-h6, 17px) !important;\n  }\n  .save-card-future-text {\n    font-size: 14px !important;\n  }\n  .accepted-card-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .summary-total-amount {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .summary-total-amount-header {\n    font-size: var(--Font-Font-Size-p, 15px) !important;\n  }\n  .summary-total-pay-now {\n    font-size: var(--Font-Font-Size-p, 15px) !important;\n  }\n  .step-2-common-col-1 {\n    width: 5% !important;\n  }\n  .step-2-common-col-2 {\n    width: 70% !important;\n  }\n  .payment-success-container-card {\n    width: 45% !important;\n  }\n  .payments-empty-campaigns-container {\n    padding: 0.5rem !important;\n  }\n  .empty-box-payments {\n    margin-bottom: 1rem !important;\n  }\n}\n@media (max-width: 767px) {\n  .complete-campaign-text-row {\n    font-size: 19px;\n  }\n  .confirm-docusign {\n    /* margin: auto; */\n    justify-content: center;\n    right: 4rem;\n    bottom: 0.5rem;\n  }\n  .agreement-button-labels {\n    width: max-content;\n  }\n  .io-container .launch-campaign-text {\n    font-size: 13px;\n    padding: 10px;\n  }\n}\n@media (min-width: 376px) and (max-width: 425px) {\n  .back-arrow-payment-main {\n    width: 25px !important;\n    height: 25px !important;\n  }\n  .complete-campaign-text-row {\n    padding: 15px 0px 15px 0px !important;\n    margin-inline-start: 10px !important;\n    gap: 10px !important;\n  }\n  .complete-campaign-text {\n    font-size: var(--Font-Font-Size-h5, 16px) !important;\n  }\n  .order-summary-scroll-main-container {\n    overflow-y: unset !important;\n    max-height: none !important;\n  }\n  .order-summary-col {\n    margin-inline-start: 0% !important;\n  }\n  .amp-does-not-store-card {\n    margin-top: 1rem !important;\n    margin: 10px !important;\n  }\n  .order-summary-apply-term-row {\n    margin: 0px !important;\n  }\n  .payment-due-col {\n    width: 100%;\n  }\n  .balance-amount-input-col {\n    width: 100%;\n  }\n  .step-2-common-col-1 {\n    width: 0% !important;\n  }\n  .step-2-common-col-2 {\n    width: 100%;\n  }\n  .amp-does-not-store-row {\n    margin-top: 1rem !important;\n  }\n  .products-title-col {\n    max-width: 60%;\n    display: flex;\n    align-items: center;\n  }\n}\n@media (min-width: 426px) and (max-width: 768px) {\n  .complete-campaign-text-row {\n    padding: 31px 0px 31px 38px !important;\n  }\n  .review-secure-row {\n    width: 100% !important;\n    padding: 10px !important;\n  }\n  .review-steps-custom.ant-steps {\n    width: 60% !important;\n  }\n  .payment-due-row {\n    gap: 5% !important;\n    display: flex !important;\n  }\n  .term-apply-final-btn {\n    height: 40px !important;\n  }\n  .add-another-term-btn-text {\n    font-size: 19px !important;\n  }\n  .remove-all-terms-plan-text {\n    font-size: 19px !important;\n  }\n  .order-summary-col {\n    margin-inline-start: 2% !important;\n  }\n  .urban-billboard-row {\n    margin-top: 0px !important;\n  }\n}\n@media (min-width: 376px) and (max-width: 425px) {\n  .review-steps-custom.ant-steps {\n    width: 100% !important;\n    display: flex !important;\n    flex-direction: row !important;\n  }\n  .review-steps-custom .ant-steps-item-icon {\n    width: 25px !important;\n    height: 25px !important;\n    line-height: 24px !important;\n    font-size: 14px !important;\n    margin-top: 4px;\n  }\n\n  .review-steps-custom .ant-steps-item-title {\n    font-size: 15px !important;\n    line-height: 20px !important;\n    margin-left: 6px !important;\n    display: inline-block;\n    vertical-align: middle;\n  }\n  .review-steps-custom.ant-steps.ant-steps-horizontal:not(\n      .ant-steps-label-vertical\n    )\n    .ant-steps-item {\n    padding-inline-start: 45px !important;\n  }\n  .review-steps-custom .ant-steps-item-container {\n    display: flex !important;\n    align-items: center !important;\n    padding: 0 4px !important;\n  }\n  .review-steps-custom.ant-steps.ant-steps-navigation .ant-steps-item::after {\n    position: absolute;\n    top: calc(50% - 0px);\n    inset-inline-start: 100%;\n    display: inline-block;\n    width: 10px;\n    height: 10px;\n    border-top: 1px solid rgba(0, 0, 0, 0.25);\n    border-bottom: none;\n    border-inline-start: none;\n    border-inline-end: 1px solid rgba(0, 0, 0, 0.25);\n    transform: translateY(-50%) translateX(-50%) rotate(45deg);\n    content: \"\";\n  }\n  .urban-billboard-sub-card {\n    overflow-x: auto;\n    white-space: normal;\n  }\n\n  .urban-billboard-sub-card .ant-row {\n    min-width: 400px !important;\n    white-space: normal;\n  }\n\n  .payment-success-container-card {\n    width: 90% !important;\n  }\n  .check-upload-front-back-row {\n    gap: 1.5rem !important;\n  }\n  .total-campaign-total-price-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .urban-billboard-blitz-text {\n    font-size: var(--Font-Font-Size-h6, 16px) !important;\n  }\n\n  .order-summary-heading {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n  }\n  .order-summary-heading-amount {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n  }\n  .choose-payment-selector-dropdown.ant-select-dropdown {\n    width: 305px !important;\n  }\n  .review-secure-row {\n    padding: 0px !important;\n    margin-bottom: 1rem !important;\n  }\n  .card-expiry-cvv-row.ant-row {\n    width: 100% !important;\n  }\n  .payment-summary-col {\n    width: 100% !important;\n  }\n  .card-input-cvv-field .ant-input:placeholder-shown {\n    text-overflow: ellipsis;\n    font-size: 18px;\n  }\n  .urban-billboard-row {\n    margin-top: 0rem !important;\n  }\n  .time-square-row {\n    margin-top: 0px !important;\n  }\n  .time-square-digital-col-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .time-square-digital-price {\n    font-size: var(--Font-Font-Size-p, 13px) !important;\n  }\n  .total-campaign-amount-label-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .balance-amount-text {\n    font-size: 14px !important;\n  }\n  .apply-term-text {\n    font-size: 14px !important;\n  }\n  .amp-store-text {\n    font-size: 14px !important;\n  }\n  .amp-store-highleted {\n    font-size: 14px !important;\n  }\n  .add-another-term-btn-text {\n    font-size: 14px !important;\n  }\n  .term-apply-final-btn-text {\n    font-size: 14px !important;\n  }\n  .remove-all-terms-plan-text {\n    font-size: 14px !important;\n  }\n  .upfront-payment-text {\n    font-size: 14px !important;\n  }\n  .upfront-payment-price-text {\n    font-size: 14px !important;\n  }\n  .proceed-to-payment-btn-text {\n    font-size: 14px !important;\n  }\n  .payment-summary-text {\n    font-size: 15px !important;\n  }\n  .summary-total-amount-header {\n    font-size: 14px !important;\n  }\n  .summary-total-amount {\n    font-size: 14px !important;\n  }\n  .late-charges-will-apply-text {\n    font-size: 14px !important;\n  }\n  .summary-total-pay-now {\n    font-size: 14px !important;\n  }\n  .summary-modify-payment-plan-text {\n    font-size: 14px !important;\n  }\n  .secure-payment-final-btn-text {\n    font-size: 14px !important;\n  }\n  .credit-debit-collapse-component\n    .ant-collapse-header\n    .ant-collapse-header-text {\n    font-size: 15px !important;\n  }\n  .payment-success-main-text {\n    font-size: var(--Font-Font-Size-h5, 18px) !important;\n  }\n  .payment-success-divider-row {\n    width: 100% !important;\n  }\n}\n\n@media (min-width: 321px) and (max-width: 375px) {\n  .review-steps-custom .ant-steps-item-icon {\n    width: 25px !important;\n    height: 25px !important;\n    line-height: 24px !important;\n    font-size: 14px !important;\n    margin-top: 4px;\n  }\n  .review-steps-custom.ant-steps.ant-steps-navigation\n    .ant-steps-item-container {\n    padding-bottom: 0px !important;\n  }\n  .urban-billboard-sub-card {\n    overflow-x: auto;\n    white-space: normal;\n  }\n\n  .urban-billboard-sub-card .ant-row {\n    min-width: 400px !important;\n    white-space: normal;\n  }\n  .complete-campaign-text {\n    font-size: var(--Font-Font-Size-h5, 15px) !important;\n  }\n\n  .complete-campaign-text-row {\n    padding: 15px 0px 15px 0px !important;\n    gap: 3%;\n    margin-left: 5% !important;\n  }\n  .back-arrow-payment-main {\n    width: 25px !important;\n  }\n  .order-summary-col {\n    margin-inline-start: 0% !important;\n  }\n  .order-summary-apply-term-row {\n    padding: 0px !important;\n  }\n  .time-square-digital-col-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .time-square-digital-price {\n    font-size: var(--Font-Font-Size-p, 13px) !important;\n  }\n  .total-campaign-amount-label-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .total-campaign-total-price-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .amp-does-not-store-card {\n    width: 96% !important;\n  }\n  .amp-store-text {\n    font-size: 14px !important;\n  }\n  .amp-store-highleted {\n    font-size: 14px !important;\n  }\n  .choose-payment-selector-dropdown.ant-select-dropdown {\n    width: 300px !important;\n  }\n  .payment-due-col {\n    width: 100% !important;\n  }\n  .balance-amount-input-col {\n    width: 100% !important;\n  }\n  .add-another-term-btn-text {\n    font-size: 14px !important;\n  }\n  .term-apply-final-btn-text {\n    font-size: 14px !important;\n  }\n  .upfront-payment-text {\n    font-size: var(--Font-Font-Size-p, 15px) !important;\n  }\n  .summary-total-amount-header {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .summary-total-amount {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .late-charges-will-apply-text {\n    font-size: 14px !important;\n  }\n  .summary-total-pay-now {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .summary-modify-payment-plan-text {\n    font-size: 15px !important;\n  }\n  .secure-payment-final-btn-text {\n    font-size: var(--Font-Font-Size-p, 15px) !important;\n  }\n  .amp-does-not-store-row {\n    margin-top: 0px !important;\n    margin-left: 0px !important;\n    padding: 10px !important;\n  }\n  .step-2-common-col-1 {\n    width: 0% !important;\n  }\n  .step-2-common-col-2 {\n    width: 100% !important;\n    margin-top: 15px !important;\n  }\n  .card-expiry-cvv-row.ant-row {\n    width: 100% !important;\n  }\n  .payment-summary-col {\n    width: 100% !important;\n  }\n  .payment-success-container-card {\n    width: 90% !important;\n  }\n  .payment-success-main-text {\n    font-size: var(--Font-Font-Size-h5, 18px) !important;\n  }\n  .payment-success-divider-row {\n    width: 100% !important;\n  }\n  .success-total-amount-paid-label {\n    font-size: 14px !important;\n  }\n  .success-total-amount-paid-label-value {\n    font-size: 14px !important;\n  }\n  .payment-success-confirmation-email-text {\n    font-size: 14px !important;\n  }\n  .payment-success-go-to-dashboard-row {\n    margin-top: 1rem !important;\n  }\n  .payment-success-download-invoice-btn-text {\n    font-size: var(--Font-Font-Size-p, 15px) !important;\n  }\n  .order-summary-heading {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n  }\n  .order-summary-heading-amount {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n  }\n  .urban-billboard-blitz-text {\n    font-size: var(--Font-Font-Size-h6, 15px) !important;\n  }\n  .review-secure-row {\n    padding: 0px !important;\n  }\n  .review-steps-custom.ant-steps {\n    width: 100% !important;\n  }\n  .ant-steps.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::after {\n    position: relative;\n    inset-inline-start: 50%;\n    display: block;\n    width: 15px;\n    height: 15px;\n    margin-bottom: 8px;\n    text-align: center;\n    transform: translateY(-50%) translateX(-50%) rotate(135deg);\n  }\n  .order-summary-scroll-main-container {\n    overflow-y: unset !important;\n    max-height: none !important;\n  }\n  .payment-success-container-card {\n    width: 90% !important;\n  }\n  .check-upload-front-back-row {\n    gap: 1.5rem !important;\n  }\n  .total-campaign-total-price-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .urban-billboard-blitz-text {\n    font-size: var(--Font-Font-Size-h6, 15px) !important;\n  }\n\n  .order-summary-heading {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n  }\n  .order-summary-heading-amount {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n  }\n  .choose-payment-selector-dropdown.ant-select-dropdown {\n    width: 305px !important;\n  }\n  .review-secure-row {\n    padding: 0px !important;\n    margin-bottom: 1rem !important;\n  }\n  .card-expiry-cvv-row.ant-row {\n    width: 100% !important;\n  }\n  .payment-summary-col {\n    width: 100% !important;\n  }\n  .card-input-cvv-field .ant-input:placeholder-shown {\n    text-overflow: ellipsis;\n    font-size: 18px;\n  }\n  .urban-billboard-row {\n    margin-top: 0rem !important;\n  }\n  .time-square-row {\n    margin-top: 0px !important;\n  }\n  .time-square-digital-col-text {\n    font-size: var(--Font-Font-Size-p, 13px) !important;\n  }\n  .time-square-digital-price {\n    font-size: var(--Font-Font-Size-p, 13px) !important;\n  }\n  .total-campaign-amount-label-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .balance-amount-text {\n    font-size: 14px !important;\n  }\n  .apply-term-text {\n    font-size: 14px !important;\n  }\n  .amp-store-text {\n    font-size: 14px !important;\n  }\n  .amp-store-highleted {\n    font-size: 14px !important;\n  }\n  .add-another-term-btn-text {\n    font-size: 14px !important;\n  }\n  .term-apply-final-btn-text {\n    font-size: 14px !important;\n  }\n  .remove-all-terms-plan-text {\n    font-size: 14px !important;\n  }\n  .upfront-payment-text {\n    font-size: 14px !important;\n  }\n  .upfront-payment-price-text {\n    font-size: 14px !important;\n  }\n  .proceed-to-payment-btn-text {\n    font-size: 14px !important;\n  }\n  .payment-summary-text {\n    font-size: 15px !important;\n  }\n  .summary-total-amount-header {\n    font-size: 14px !important;\n  }\n  .summary-total-amount {\n    font-size: 14px !important;\n  }\n  .late-charges-will-apply-text {\n    font-size: 14px !important;\n  }\n  .summary-total-pay-now {\n    font-size: 14px !important;\n  }\n  .summary-modify-payment-plan-text {\n    font-size: 14px !important;\n  }\n  .secure-payment-final-btn-text {\n    font-size: 14px !important;\n  }\n  .credit-debit-collapse-component\n    .ant-collapse-header\n    .ant-collapse-header-text {\n    font-size: 15px !important;\n  }\n  .payment-success-main-text {\n    font-size: var(--Font-Font-Size-h5, 18px) !important;\n  }\n  .payment-success-divider-row {\n    width: 100% !important;\n  }\n  .products-title-col {\n    max-width: 60%;\n    display: flex;\n    align-items: center;\n  }\n}\n@media (min-width: 0px) and (max-width: 320px) {\n  .products-title-col {\n    max-width: 60%;\n    display: flex;\n    align-items: center;\n  }\n  .urban-billboard-sub-card {\n    overflow-x: auto;\n    white-space: normal;\n  }\n\n  .urban-billboard-sub-card .ant-row {\n    min-width: 400px !important;\n    white-space: normal;\n  }\n  .complete-campaign-text-row {\n    padding: 15px 0px 15px 0px !important;\n    margin-inline-start: 4%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n  .complete-campaign-text {\n    font-size: var(--Font-Font-Size-h5, 13px) !important;\n  }\n  .back-arrow-payment-main {\n    width: 20px !important;\n  }\n  .order-summary-col {\n    margin-inline-start: 0% !important;\n  }\n  .review-steps-custom.ant-steps {\n    margin-top: 0px !important;\n  }\n  .review-secure-row {\n    padding: 0px !important;\n  }\n  .order-summary-col {\n    padding: 0px !important;\n  }\n  .upfront-text-label-name {\n    font-size: var(--Font-Font-Size-small, 12px) !important;\n  }\n  .time-square-digital-price {\n    font-size: var(--Font-Font-Size-p, 12px) !important;\n  }\n  .time-square-digital-col-text {\n    font-size: var(--Font-Font-Size-p, 12px) !important;\n  }\n  .total-campaign-amount-label-text {\n    font-size: var(--Font-Font-Size-p, 12px) !important;\n  }\n  .total-campaign-total-price-text {\n    font-size: var(--Font-Font-Size-p, 12px) !important;\n  }\n  .amp-store-text {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n  .amp-store-highleted {\n    font-size: 14px !important;\n    line-height: 20px !important;\n  }\n  .balance-amount-text {\n    font-size: 15px !important;\n  }\n  .balance-amount-input-col {\n    width: 100% !important;\n  }\n  .payment-due-col {\n    width: 100% !important;\n  }\n  .add-another-term-row {\n    flex-wrap: wrap !important;\n  }\n  .add-another-term-col {\n    margin-bottom: 10px !important;\n    margin-top: 10px !important;\n  }\n  .upfront-payment-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .upfront-payment-price-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .term-apply-final-btn-text {\n    font-size: 14px !important;\n  }\n  .proceed-to-payment-btn-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .remove-all-terms-plan-text {\n    font-size: 14px !important;\n  }\n  .add-another-term-btn-text {\n    font-size: 15px !important;\n  }\n  .proceed-to-payment-btn {\n    height: 40px !important;\n  }\n  .payment-summary-text {\n    font-size: var(--Font-Font-Size-h6, 17px) !important;\n  }\n  .summary-total-amount {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .summary-total-amount-header {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .late-charges-will-apply-text {\n    font-size: 14px !important;\n    line-height: 15.5px !important;\n  }\n  .summary-total-pay-now {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .summary-modify-payment-plan-text {\n    font-size: 14px !important;\n  }\n  .secure-payment-final-btn {\n    height: 40px !important;\n  }\n  .secure-payment-final-btn-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .amp-does-not-store-row {\n    margin-top: 1.2rem !important;\n  }\n  .step-2-common-col-1 {\n    width: 0% !important;\n  }\n  .step-2-common-col-2 {\n    width: 100% !important;\n  }\n  .amp-does-not-store-row {\n    margin-top: 0px !important;\n    margin-left: 0px !important;\n    padding: 10px !important;\n  }\n  .card-expiry-cvv-row.ant-row {\n    width: 100% !important;\n    gap: 0rem !important;\n  }\n  .card-expiry-number-col {\n    width: 100% !important;\n  }\n  .card-expiry-month-col {\n    width: 100% !important;\n  }\n  .payment-summary-col {\n    width: 100% !important;\n  }\n  .review-secure-row {\n    padding: 0px !important;\n  }\n  .review-steps-custom.ant-steps {\n    width: 100% !important;\n  }\n  .order-summary-scroll-main-container {\n    overflow-y: unset !important;\n    max-height: none !important;\n  }\n  .payment-success-container-card {\n    width: 90% !important;\n  }\n  .check-upload-front-back-row {\n    gap: 1.5rem !important;\n  }\n  .total-campaign-total-price-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .urban-billboard-blitz-text {\n    font-size: var(--Font-Font-Size-h6, 15px) !important;\n  }\n\n  .order-summary-heading {\n    font-size: 16px !important;\n    font-weight: 600 !important;\n  }\n  .order-summary-heading-amount {\n    font-size: 14px !important;\n    font-weight: 600 !important;\n  }\n  .choose-payment-selector-dropdown.ant-select-dropdown {\n    width: 305px !important;\n  }\n  .review-secure-row {\n    padding: 0px !important;\n    margin-bottom: 1rem !important;\n  }\n  .card-expiry-cvv-row.ant-row {\n    width: 100% !important;\n  }\n  .payment-summary-col {\n    width: 100% !important;\n  }\n  .card-input-cvv-field .ant-input:placeholder-shown {\n    text-overflow: ellipsis;\n    font-size: 18px;\n  }\n  .urban-billboard-row {\n    margin-top: 0rem !important;\n  }\n  .time-square-row {\n    margin-top: 0px !important;\n  }\n  .time-square-digital-col-text {\n    font-size: var(--Font-Font-Size-p, 13px) !important;\n  }\n  .time-square-digital-price {\n    font-size: var(--Font-Font-Size-p, 13px) !important;\n  }\n  .total-campaign-amount-label-text {\n    font-size: var(--Font-Font-Size-p, 14px) !important;\n  }\n  .balance-amount-text {\n    font-size: 14px !important;\n  }\n  .apply-term-text {\n    font-size: 14px !important;\n  }\n  .amp-store-text {\n    font-size: 14px !important;\n  }\n  .amp-store-highleted {\n    font-size: 14px !important;\n  }\n  .add-another-term-btn-text {\n    font-size: 14px !important;\n  }\n  .term-apply-final-btn-text {\n    font-size: 14px !important;\n  }\n  .remove-all-terms-plan-text {\n    font-size: 14px !important;\n  }\n  .upfront-payment-text {\n    font-size: 14px !important;\n  }\n  .upfront-payment-price-text {\n    font-size: 14px !important;\n  }\n  .proceed-to-payment-btn-text {\n    font-size: 14px !important;\n  }\n  .payment-summary-text {\n    font-size: 15px !important;\n  }\n  .summary-total-amount-header {\n    font-size: 14px !important;\n  }\n  .summary-total-amount {\n    font-size: 14px !important;\n  }\n  .late-charges-will-apply-text {\n    font-size: 14px !important;\n  }\n  .summary-total-pay-now {\n    font-size: 14px !important;\n  }\n  .summary-modify-payment-plan-text {\n    font-size: 14px !important;\n  }\n  .secure-payment-final-btn-text {\n    font-size: 14px !important;\n  }\n  .credit-debit-collapse-component\n    .ant-collapse-header\n    .ant-collapse-header-text {\n    font-size: 15px !important;\n  }\n  .payment-success-main-text {\n    font-size: var(--Font-Font-Size-h5, 18px) !important;\n  }\n  .payment-success-divider-row {\n    width: 100% !important;\n  }\n  .ant-steps.ant-steps-navigation.ant-steps-vertical > .ant-steps-item::after {\n    position: relative;\n    inset-inline-start: 50%;\n    display: block;\n    width: 15px;\n    height: 15px;\n    margin-bottom: 8px;\n    text-align: center;\n    transform: translateY(-50%) translateX(-50%) rotate(135deg);\n  }\n}\n@media (max-width: 768px) {\n  .purchase-main-component {\n    overflow-x: hidden !important;\n  }\n  .scrollable-content {\n    overflow-x: hidden !important;\n  }\n  .payment-success-container-card {\n    width: 60%;\n    background: #ffffff;\n    box-shadow: 0px 236px 66px 0px #00000000;\n  }\n}\n.review-steps-custom.ant-steps.ant-steps-vertical\n  > .ant-steps-item\n  .ant-steps-item-content {\n  display: block;\n  min-height: 24px !important;\n  overflow: hidden;\n}\n.payment-terms-cell {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.payment-terms-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  white-space: nowrap;\n}\n\n.payment-term-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 6px;\n  border-radius: 5px;\n  font-size: 11px;\n  line-height: 16px;\n  font-weight: 400;\n}\n\n.payment-term-upfront {\n  background: #fff1f3;\n  color: #d2042d;\n}\n\n.payment-term-installment {\n  background: #f2f4f7;\n  color: #475467;\n}\n\n.payment-term-date {\n  color: #667085;\n  font-size: 12px;\n}\n\n.payment-term-percentage {\n  color: #667085;\n  font-size: 12px;\n}\n.payment-term-amount-new {\n  color: #101828;\n  font-size: 12px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
